<template>
  <div>
    <section class="page-title contrato pf-title">
      <div class="center">
        <router-link to="/pessoafisica" class="back-button fas fa-angle-left"></router-link>
        <p class="label-planos">Pessoa Física</p>
        <h1 class="the-title">Contrato</h1>
      </div>
    </section>

    <section class="page-content center planos-form">
      <div class="plano-selecionado" style="background: #f1f1f1;" v-if="planoSelecionado.name"><span>{{planoSelecionado.name}} - R$ {{(parseFloat(planoSelecionado.value.replace(',','.')) - planoSelecionado.descontoAvista).toFixed(2).replace('.', ',')}} (por pet) </span></div>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1" step="1">Primeiro Acesso</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 2" step="2" :editable="editaDadosPessoais" >Dados Pessoais</v-stepper-step>
          <!-- <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Anexos</v-stepper-step> -->
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 3" step="3" :editable="editaEndereco">Endereço</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step :complete="e1 > 4" step="4" :editable="editaPets">Pets</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="5" :editable="editPassos">Contratar o Plano</v-stepper-step>
        </v-stepper-header>
      
        <v-stepper-items>
          <!-- PASSO 1 -->
          <v-stepper-content step="1">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg3>      
                    <v-text-field
                      v-model="financialManagers.cpf"
                      label="CPF*"
                      v-validate="'required|cpf'"
                      :error-messages="errors.collect('cpf')"
                      return-masked-value mask="###.###.###-##"
                      data-vv-name="cpf"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg5>      
                    <v-text-field
                      v-model="financialManagers.email"
                      v-validate="'required|email'"
                      :error-messages="errors.collect('email')"
                      label="E-mail*"
                      data-vv-name="email"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg2>      
                    <v-text-field
                      v-model="financialManagers.password"
                      label="Senha*"
                      v-validate="'required'"
                      :error-messages="errors.collect('senha')"
                      type="password"
                      ref="password"
                      data-vv-name="senha"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg2>      
                    <v-text-field
                      v-model="financialManagers.confirmPassword"
                      label="Repetir Senha*"
                      type="password"
                      :error-messages="errors.collect('password')"
                      v-validate="'required|confirmed:password'"
                      data-vv-name="password"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg9>      
                    <v-text-field
                      v-model="financialManagers.firstName"
                      label="Nome Completo*"
                      box
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                      :error-messages="errors.collect('firstName')"
                      data-vv-name="firstName"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>      
                    <v-text-field
                      v-model="financialManagers.cellPhone"
                      label="Celular*"
                      return-masked-value mask="(##)#####-####"
                      v-validate="'required'"   
                      :error-messages="errors.collect('Celular')"
                      data-vv-name="Celular"
                      box
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg3>      
                    <v-select
                      box
                      v-model="financialManagers.state"
                      :items="estados"
                      item-text="prefix"
                      item-value="codeS4"
                      label="UF*"
                      v-validate="'required'"
                      :error-messages="errors.collect('uf')"
                      data-vv-name="uf"
                    ></v-select>
                  </v-flex> -->
                </v-layout>        
              </v-card>     
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="salvarPrimeiroAcesso()">Continuar</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 1 -->

          <v-dialog v-model="dialogStep1" max-width="550px" max-height="300px" persistent> 
            <v-card style="border-radius: 10px;">
              <v-container grid-list-md>
                <v-layout row wrap justify-center>
                  <v-card-title>
                    <span class="total">ATENÇÃO</span>              
                  </v-card-title>
                  <v-container fill-height fluid pa-1 justify-center>
                    <p class="subtotal" style="text-align: center; text-size: 12px">Já existe um cadastro para este e-mail informado. Para visualizar, acesse a Área do Cliente ou clique em "Continuar" para prosseguir.</p>
                  </v-container>
                </v-layout>
                <v-card-actions style="margin: 25px auto auto auto;">
                  <v-container fill-height fluid pa-1 justify-center>
                    <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 150px" dark @click="confirmaContrato()">Área do Cliente</v-btn>
                    <v-btn color="#8395A7" style="border-radius: 8px; width: 150px;" dark @click="continueStep2()">Continuar</v-btn>
                  </v-container>
                </v-card-actions>
              </v-container>
            </v-card>
          </v-dialog>

          <!-- PASSO 2 -->
          <v-stepper-content step="2">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg8>      
                    <v-text-field
                      disabled
                      v-model="financialManagers.firstName"
                      label="Nome Completo"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-select
                      v-model="financialManagers.gender"
                      label="Sexo*"
                      v-validate="'required'"
                      :error-messages="errors.collect('gender')"
                      data-vv-name="gender"
                      :items="generos"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="dataNasc"
                      label="Data de Nascimento*"
                      v-validate="'required|date_format:dd/MM/yyyy'"
                      :error-messages="errors.collect('dateOfBirth')"
                      return-masked-value mask="##/##/####"
                      data-vv-name="dateOfBirth"
                      box
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg4>      
                    <v-select
                      v-model="financialManagers.maritalStatus"
                      label="Estado Civil*"
                      v-validate="'required'"
                      :error-messages="errors.collect('maritalStatus')"
                      data-vv-name="maritalStatus"
                      :items="estadoscivil"
                      item-text="text"
                      item-value="value"
                      box
                    ></v-select>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.cpf"
                      label="CPF"
                      disabled
                      box
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.susNumber"
                      label="CNS (Cartão do SUS)"
                      v-validate="'cns'"
                      :error-messages="errors.collect('cns')"
                      data-vv-name="cns"
                      box
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.cellPhone"
                      label="Celular*"
                      return-masked-value mask="(##)#####-####"
                      disabled
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>      
                    <v-text-field
                      v-model="financialManagers.rg"
                      label="RG*"
                      v-validate="'required'"
                      :error-messages="errors.collect('rg')"
                      data-vv-name="rg"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>      
                    <v-text-field
                      v-model="financialManagers.rgEmitter"
                      label="Órgão Expedidor*"
                      v-validate="'required'"
                      :error-messages="errors.collect('rgEmissor')"
                      data-vv-name="rgEmissor"
                      box
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg6>      
                    <v-text-field
                      v-model="financialManagers.motherName"
                      label="Nome da Mãe*"
                      v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                      :error-messages="errors.collect('motherName')"
                      data-vv-name="motherName"
                      box
                    ></v-text-field>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg6>      
                    <v-text-field
                      v-model="financialManagers.email"
                      label="E-mail"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <!-- <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.homePhone"
                      return-masked-value mask="(##)####-####"
                      label="Telefone Fixo"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.cellPhone2"
                      label="Whatsapp"
                      return-masked-value mask="(##)#####-####"
                      box
                    ></v-text-field>
                  </v-flex> -->
                  <!-- <v-flex xs12 sm12 lg12>            
                    <v-radio-group v-model="financialManagers.contratanteTitular" row :disabled="!radioBTtitular">
                      <strong style="font-weight: bold;">O contratante será o beneficiário titular do plano? &nbsp;&nbsp;</strong>
                      <v-radio color="#8395A7" label="Sim" :value="true"></v-radio>
                      <v-radio color="#8395A7" label="Não" :value="false"></v-radio>
                    </v-radio-group>
                  </v-flex> -->
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso3()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark @click="salvarContinuar()" color="blue-grey darken-1">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 2 -->

          <!-- PASSO 3 --> 
          <v-stepper-content step="3">
            <v-container grid-list-md>
              <v-card class="mb-5" min-height="200px" flat>
                <v-layout row wrap>
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="financialManagers.cep"
                      label="CEP*"
                      return-masked-value mask="#####-###"
                      v-validate="'required'"
                      :error-messages="errors.collect('cep')"
                      data-vv-name="cep"
                      @blur="retornoCEP()"
                      box
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg9>      
                    <v-text-field
                      v-model="financialManagers.address"
                      label="Rua"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>      
                    <v-text-field
                      v-model="financialManagers.addressNumber"
                      label="Número*"
                      type="number"
                      v-validate="'required'"
                      :error-messages="errors.collect('numero')"
                      data-vv-name="numero"
                      box
                    ></v-text-field>
                  </v-flex>
                    <v-flex xs12 sm12 lg4>      
                      <v-text-field
                        v-model="bairro"
                        label="Bairro"
                        box
                        disabled
                      ></v-text-field>
                    </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="cidade"
                      label="Cidade"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>      
                    <v-text-field
                      v-model="estado"
                      label="Estado"
                      box
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm12 lg12>
                    <v-text-field
                      v-model="financialManagers.addressComplement"
                      label="Complemento"
                      box
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-card>
              <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso5()">Continuar</v-btn>
              <v-btn style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1" @click="salvarContinuar()">Salvar e continuar depois</v-btn>
            </v-container>
          </v-stepper-content>
          <!-- FIM DO PASSO 3 -->

          <!-- PASSO 4 -->
          <v-stepper-content step="4">  
            <v-alert :value="alertTitular" type="info" color="primary">
              Informe um Titular para o plano!
            </v-alert>    
            <v-container fluid grid-list-md>
              <v-data-iterator
                v-if="!alertTitular"
                :items="dependentes"
                :rows-per-page-items="rowsPerPageItems"
                rows-per-page-text="Linhas por página" 
                :pagination.sync="pagination"
                content-tag="v-layout"
                row
                wrap
                hide-actions
              >
                <template v-slot:header>
                  <v-toolbar style="border-radius: 10px;" class="mb-2" color="#8395A7" dark flat>
                    <v-toolbar-title>Titular/Dependentes</v-toolbar-title>
                  </v-toolbar>
                </template>
                <template v-slot:item="props">
                  <v-flex xs12 sm6 md4 lg4>
                    <v-card style="border-radius: 10px;">
                      <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.firstName.toUpperCase() }}</v-card-title>
                      <v-divider></v-divider>
                      <v-list dense>
                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >{{ props.item.namePlan}}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >{{ props.item.parentage == '' ? 'TITULAR' : props.item.parentage}}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>
                          <v-list-tile-content class="centralizar" >R$ {{ props.item.valuePlan }}</v-list-tile-content>
                        </v-list-tile>
                        <v-list-tile>                
                          <v-btn
                            style="border-radius: 8px;"
                            dark
                            color="blue-grey darken-1"
                            @click="editItem(props.item)"
                          >Editar</v-btn>
                          <v-btn
                            v-if="!props.item.isHolder"
                            style="border-radius: 8px;"
                            dark
                            color="error"
                            @click="openDialogDelete(props.item)"
                          >Excluir</v-btn>                
                        </v-list-tile>
                      </v-list>
                    </v-card>
                  </v-flex>
                </template>      
              </v-data-iterator>
            </v-container>

            <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
            <v-flex xs12 sm12 lg12>
              <v-container grid-list-md v-if="!alertTitular">
                <v-layout row wrap justify-center>
                  <v-btn @click="openDialogDependete()" dark style="border-radius: 8px;" large color="#cc9966" :disabled="inserirDepBloq">Incluir Pet</v-btn>
                </v-layout>
              </v-container>
            </v-flex>
            <v-dialog v-model="dialog" max-width="850px" persistent>                      
              <v-card>                                                        
                <v-card-title v-if="!dependents.isHolder">
                  <span class="headline">{{ formTitle }}</span>                               
                </v-card-title>
                <v-card-title v-else>
                  <span class="headline">{{ formTitleTitular }}</span>                               
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm12 lg12 v-if="dependents.isHolder">
                        <v-select  
                          v-model="selecaoPlano"
                          label="Plano Selecionado*"                
                          :items="planos"
                          v-validate="'required'"
                          :error-messages="errors.collect('selecaoplan')"
                          data-vv-name="selecaoplan"
                          item-text="descricao"
                          item-value="id"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg12 v-else>
                        <v-select  
                          v-model="selecaoPlano"
                          label="Plano Selecionado*"                
                          :items="planos"
                          v-validate="'required'"
                          :error-messages="errors.collect('selecaoplan')"
                          data-vv-name="selecaoplan"
                          item-text="descricao"
                          item-value="id"
                          box
                        ></v-select>
                      </v-flex>               
                      <!-- <v-flex xs12 sm12 lg4 v-if="!dependents.isHolder">      
                        <v-select
                          v-model="dependents.parentage"
                          label="Parentesco*"
                          v-validate="'required'"
                          :error-messages="errors.collect('parentage')"
                          data-vv-name="parentage"
                          :items="parentesco"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex> -->
                      <v-flex xs12 sm12 lg6 v-if="!dependents.isHolder">      
                        <v-text-field
                          v-model="dependents.firstName"
                          label="Nome do Pet*"
                          box
                          v-validate="'required'"
                          :error-messages="errors.collect('firstNameDep')"
                          data-vv-name="firstNameDep"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 lg6 v-else>      
                        <v-text-field
                          v-model="dependents.firstName"
                          label="Nome do Pet*"
                          box
                          v-validate="'required'"
                          :error-messages="errors.collect('firstNameDep')"
                          data-vv-name="firstNameDep"
                        ></v-text-field>
                      </v-flex>
                      <!-- <v-flex xs12 sm12 lg4>      
                        <v-text-field
                          v-model="dependents.cpf"
                          label="CPF*"
                          v-validate="'required|cpf'"
                          :error-messages="errors.collect('cpfDep')"
                          return-masked-value mask="###.###.###-##"
                          data-vv-name="cpfDep"
                          box
                        ></v-text-field>
                      </v-flex>  -->             
                      <v-flex xs12 sm12 lg3>      
                        <v-text-field
                          v-model="dataNascDependent"
                          label="Data de Nascimento*"
                          hint="pode ser a data estimada"
                          persistent-hint
                          v-validate="'required|date_format:dd/MM/yyyy'"
                          :error-messages="errors.collect('dateOfBirthDep')"
                          return-masked-value mask="##/##/####"
                          data-vv-name="dateOfBirthDep"
                          box
                        ></v-text-field>
                      </v-flex>                            
                      <!-- <v-flex xs12 sm12 lg4>      
                        <v-text-field
                          v-model="dependents.susNumber"
                          label="CNS (Cartão do SUS)"
                          v-validate="'cns'"
                          :error-messages="errors.collect('cns')"
                          data-vv-name="cns"
                          box
                        ></v-text-field>
                      </v-flex> --> 
                      <!-- <v-flex xs12 sm12 lg3>      
                        <v-select
                          v-model="dependents.maritalStatus"
                          label="Estado Civil*"
                          v-validate="'required'"
                          :error-messages="errors.collect('maritalStatusDep')"
                          data-vv-name="maritalStatusDep"
                          :items="estadoscivil"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex> -->
                      <v-flex xs12 sm12 lg3>
                        <v-select
                          v-model="dependents.gender"
                          label="Sexo*"
                          v-validate="'required'"
                          :error-messages="errors.collect('genderDep')"
                          data-vv-name="genderDep"
                          :items="generosPet"
                          item-text="text"
                          item-value="value"
                          box
                        ></v-select>
                      </v-flex>
                      <!-- <v-flex xs12 sm12 lg6>      
                        <v-text-field
                          v-model="dependents.motherName"
                          label="Nome da Mãe*"
                          v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                          :error-messages="errors.collect('motherNameDep')"
                          data-vv-name="motherNameDep"
                          box
                        ></v-text-field>
                      </v-flex>  -->
                      <v-flex xs12 sm12 lg6>
                        <v-select
                          v-model="dependents.especie"
                          label="Espécie*"
                          v-validate="'required'"
                          :error-messages="errors.collect('especieDep')"
                          data-vv-name="especieDep"
                          :items="especies"
                          item-text="nome"
                          item-value="codeS4"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg6 v-if="dependents.especie == 1">
                        <v-select
                          v-model="dependents.raca"
                          label="Raça do Cão"
                          :items="filteredItems"
                          item-text="nome"
                          item-value="codeS4"
                          box
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 lg6 v-if="dependents.especie == 2">
                        <v-select
                          v-model="dependents.raca"
                          label="Raça do Gato"
                          :items="filteredItems"
                          item-text="nome"
                          item-value="codeS4"
                          box
                        ></v-select>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>          
                  <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarDependente">Salvar</v-btn>
                  <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG DEPENDENTES --> 

            <!-- DIALOG DELETA DEPENDENTE -->
            <v-dialog v-model="dialogDelete" max-width="600px" persistent> 
              <v-card>
                <v-card-title>
                  <span class="headline">Confirmação de Exclusão</span>
                </v-card-title>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-card-text>Pet: {{dependents.firstName}}</v-card-text>
                    <v-card-text>Parentesco: {{dependents.parentage}}</v-card-text>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="deleteDependente()">Excluir</v-btn>
                  <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG DELETA DEPENDENTE -->

            <!-- DIALOG CARTÃO DE CRÉDITO -->
            <v-dialog v-model="dialogCartao" max-width="900px" persistent> 
              <v-card>
                <v-card-title>
                  <span  class="headline">Pagamento com Cartão de Crédito</span>
                </v-card-title>
                <v-container grid-list-md>
                  <!-- <v-flex xs12 sm12 lg12>            
                      <p style="color:#F57C00" class="subtotal">O cartão deve pertencer ao responsável financeiro*</p>
                      <br>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg12 >
                    <p class="form-titulo">Dados do Cartão de Crédito</p>
                  </v-flex>
                  <v-layout row wrap>
                    <v-flex d-flex xs12 sm6 md6>
                      <vue-card :number='modelCartao.cartao.numero' :cvv='modelCartao.cartao.codigoSeguranca' :mes='modelCartao.cartao.expiracaoMes' :nome='modelCartao.cartao.nome' :ano='validadeCartaoAno' animate :side='side'/>
                    </v-flex>
                    <v-flex d-flex xs12 sm6 md6 >
                      <v-layout row wrap>
                        <v-flex d-flex xs12 sm6 md12 >
                          <v-text-field              
                            v-model="modelCartao.cartao.nome"
                            label="Nome (Como está impresso no Cartão)"
                            v-validate="'required'"
                            :error-messages="errors.collect('nomeCartao')"
                            data-vv-name="nomeCartao"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md6>
                          <v-text-field
                            v-model="modelCartao.cartao.numero"
                            label="Número do Cartão"
                            v-validate="'required|credit_card'"
                            :error-messages="errors.collect('numCartao')"
                            data-vv-name="numCartao"
                            mask="#### #### #### ####"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md6>
                          <v-select
                            v-model="modelCartao.cartao.bandeira"
                            label="Bandeira"
                            v-validate="'required'"
                            :error-messages="errors.collect('bandeiraCartao')"
                            data-vv-name="bandeiraCartao"
                            :items="bandeiras"
                            item-text="text"
                            item-value="value"
                            box
                            @keydown="side=1"
                          ></v-select>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md4>          
                          <v-text-field
                            v-model="modelCartao.cartao.expiracaoMes"
                            label="Validade Mês"
                            v-validate="'required'"
                            :error-messages="errors.collect('expiraCartaoMes')"
                            data-vv-name="expiraCartaoMes"
                            return-masked-value mask="##"
                            box
                            @keydown="side=1"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm6 md4> 
                          <v-select
                            v-model="validadeCartaoAno"
                            label="Validade Ano*"
                            v-validate="'required'"
                            :error-messages="errors.collect('expiraCartaoAno')"
                            data-vv-name="expiraCartaoAno"
                            :items="anoValidade"
                            @keydown="side=1"
                            box
                          ></v-select>
                        </v-flex>                    
                        <v-flex d-flex xs12 sm6 md4> 
                          <v-text-field
                            v-model="modelCartao.cartao.codigoSeguranca"
                            label="CVV"
                            v-validate="`required`"
                            :error-messages="errors.collect('codCartao')"
                            data-vv-name="codCartao"
                            mask="####"
                            box
                            @keydown="side=2"
                          ></v-text-field>
                        </v-flex>
                        <v-flex d-flex xs12 sm12 md12 v-if="pagamentoTipoCartao == 'anualParcelado'">
                          <v-select
                            v-model="modelCartao.quantidadeParcelas"
                            label="Quantidade de Parcelas"
                            v-validate="'required'"
                            :error-messages="errors.collect('qtdParcelasCartao')"
                            data-vv-name="qtdParcelasCartao"
                            :items="qtdParcelas"
                            item-text="text"
                            item-value="value"
                            box
                            @keydown="side=1"
                          ></v-select>
                        </v-flex>
                      </v-layout>
                    </v-flex>                    
                  </v-layout>  
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn v-if="!this.pegaDadosCartao" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="pagarCartao()">Confirmar</v-btn>
                    <v-btn v-else color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="enviarProposta()">Confirmar</v-btn>
                    <v-btn v-if="planoSelecionado.typePayment == 'DEBITO'" color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="pagarDebito()">Confirmar</v-btn>
                    <v-btn color="red darken-1" style="border-radius: 8px; width: 130px;" dark @click.native="close()">Cancelar</v-btn>
                  </v-card-actions>
                </v-container>          
              </v-card>
            </v-dialog>
            <!-- FIM DIALOG CARTÃO DE CRÉDITO --> 
        
            <br>
            <v-flex xs12 sm12 lg12 v-if="alertTitular">
              <v-container grid-list-md>
                <v-layout row wrap justify-center>
                  <v-btn
                    style="border-radius: 8px;"
                    large                
                    dark
                    color="#cc9966"
                    @click="openDialog()"
                  >Incluir Pet Titular</v-btn>
                </v-layout>
              </v-container>
              <br>
              <br>
            </v-flex>
            <div class="separator dark"></div>
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 lg12>
                  <div class="total-table">
                    <p class="form-titulo" >Valores</p>
                    <div class="row-table-wrapper">                  
                      <div class="col" style="width: 36%;">
                        <div class="row-table titular">
                          <p>Pet Titular</p>
                          <span class="total">R$ {{valorTitular.replace('.',',')}}</span>
                        </div>
                        <div class="row-table dependentes-row">
                          <p>Pet Dependente(s)</p>
                          <span class="total">R$ {{valorDependentes}}</span>
                        </div>
                      </div>
                      <div class="col" style="margin-right: 14%;"  v-if="planoSelecionado.taxaImplantacao != '0,00'">
                        <div class="row-table total-row">
                          <p>Total a pagar + Taxa de Implantação</p>
                          <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>                        
                      </div>
                      <div class="col" style="margin-right: 14%;" v-else>
                        <div class="row-table total-row">
                          <p>Total a pagar</p>
                          <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                        </div>                        
                      </div>
                    </div>
                  </div>
                </v-flex>
                <v-flex xs12 sm12 lg12  v-if="planoSelecionado.taxaImplantacao != '0,00'">
                  <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pet (Apenas na primeira mensalidade)</p> 
                </v-flex>
              </v-layout>
            </v-container>
            <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
            <v-card-actions>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <v-flex md12 xs12 sm12 lg2>
                    <v-btn style="border-radius: 8px;" large dark color="#8395A7" @click="avancaPasso6()">Continuar</v-btn>
                  </v-flex>
                  <v-flex md12 xs12 sm12 lg2>
                    <v-btn @click="salvarContinuar()" style="border-radius: 8px; width: 250px;" large dark color="blue-grey darken-1">Salvar e continuar depois</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-actions>
          </v-stepper-content>
          <!-- FIM DO PASSO 4 -->

          <!-- PASSO 5 -->
          <v-stepper-content step="5">
            <v-card class="mb-5" min-height="200px" flat>
              <v-container grid-list-md>
                <v-layout row wrap>
                  <!-- <v-flex xs12 sm12 lg12 v-if="exibeVendedor">      
                    <p class="form-titulo" >Corretor</p>
                    <v-flex xs12 sm12 lg12>            
                      <v-radio-group v-model="temVendedor" row :disabled="linkVendedor">
                        <strong style="font-weight: bold;">Você foi auxiliado por algum corretor? &nbsp;&nbsp;</strong>
                        <v-radio color="#446fb5" label="Sim" :value="true"></v-radio>
                        <v-radio color="#446fb5" label="Não" :value="false"></v-radio>
                      </v-radio-group>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="!linkVendedor">
                      <v-text-field                
                        v-if="temVendedor ? true : cpfVendedor = ''"
                        v-model="cpfVendedor"
                        label="CPF"                
                        box
                        return-masked-value mask="###.###.###-##"
                        @blur="consultaVendedor()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>      
                      <v-text-field
                        v-if="temVendedor ? temVendedor == true : nomeVendedor = ''"
                        v-model="nomeVendedor"
                        label="Corretor"
                        box
                        disabled
                      ></v-text-field>
                    </v-flex>
                    <hr>
                    <br>
                  </v-flex> -->
                  <v-flex xs12 sm12 lg12 v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined">      
                    <p class="form-titulo" >Contrato</p>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg8 v-if="planoSelecionado.urlContrato != '' && planoSelecionado.urlContrato != undefined" @click="pdfSelecionado = planoSelecionado.urlContrato">
                    <iframe  v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}#zoom=80`" width="680" height="400" ></iframe>
                  </v-flex>
                  <v-flex xs12 sm12 md12 lg4>
                    <div v-for="item in documentosPlano" :key="item.id">
                      <div class="hidden-md-and-down" v-if="item.urlContrato">
                        <v-list-tile @click="pdfSelecionado = item.urlContrato" avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Contrato {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>
                      <div class="hidden-md-and-down" v-if="item.urlCobertura">
                        <v-list-tile @click="pdfSelecionado = item.urlCobertura" avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Cobertura {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>
                      <div class="hidden-lg-and-up" v-if="item.urlContrato">
                        <v-list-tile @click="pdfSelecionado = item.urlContrato" :href="item.urlContrato" target='_blank' avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Contrato {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>
                      <div class="hidden-lg-and-up" v-if="item.urlCobertura">
                        <v-list-tile @click="pdfSelecionado = item.urlCobertura" :href="item.urlCobertura" target='_blank' avatar>
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Cobertura {{item.name}}</v-list-tile-title>
                        </v-list-tile>
                      </div>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm3 md12 lg12>
                    <v-checkbox v-model="contrataccept" color="#7e2985">
                      <span slot="label">Estou de acordo com os Termos e Condições de Contratação</span>
                    </v-checkbox>
                    <!-- <v-checkbox v-model="contractAcceptPoliticaPrivacidade" color="#7e2985">
                      <span slot="label">Estou de acordo com a <a href="https://maispetoficial.intelite.com.br/docs/Politica_de_Privacidade_MAIS_PET.pdf" target="_blank">Política de Privacidade</a> e Cookies do Mais Pet</span>
                    </v-checkbox> -->
                    <v-checkbox v-model="contractAcceptComunicacoes" color="#7e2985">
                      <span slot="label">Estou de acordo em receber comunicações em geral da {{informacaoOperadora("nome")}}</span>
                    </v-checkbox>
                    <v-radio-group v-model="financialManagers.petSaudavel" column>
                      <v-radio color="#7e2985" label="Declaro para os devidos fins que o meu Pet se encontra saudável, sem doenças pré-existentes de meus conhecimentos" value="true"></v-radio>
                      <br>
                      <v-radio color="#7e2985" label="Declaro para os devidos fins que o meu Pet apresenta doenças pré-existentes e/ou uso continuo de medicamentos" value="false"></v-radio>
                    </v-radio-group>
                  </v-flex>

                  <!-- <v-dialog v-model="modal" max-width="700px" max-height="400px"> 
                    <v-card>
                      <v-container grid-list-md>
                        <v-layout row wrap justify-center>
                          <v-card-title>
                            <span class="total">Prezado(a) cliente,</span>              
                          </v-card-title>
                          <v-container fluid pa-1 justify-center class="resumo">
                            <p class="resumo" >Caso o resultado da avaliação ateste a inaptidão do BENEFICIÁRIO para participar do plano assistencial, a consulta será restituída ao representante do BENEFICIÁRIO, esclarecendo que caso o pet seja um cão, a restituição será na sua integralidade, e se for um gato este será de 50% (cinquenta porcento).</p>
                            <br>
                            <p class="resumo" >O ressarcimento (consulta de avaliação) será feito diretamente pelas CLÍNICAS ao CONTRATANTE, já o ressarcimento do valor do plano de saúde será pago diretamente pela OPERADORA ao TUTOR do BENEFICIÁRIO.</p>
                            <br>                    
                            <v-checkbox v-model="contratacceptConsulta" color="#00AEEF">
                              <span slot="label">Estou ciente e concordo com o exposto acima.</span>
                            </v-checkbox>
                          </v-container>
                        </v-layout>
                        <v-card-actions>
                          <v-container fill-height fluid pa-1 justify-center>
                            <br>
                            <v-btn @click="confirmaAceiteAdicional()" color="#00AEEF" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
                          </v-container>
                        </v-card-actions>
                      </v-container>
                    </v-card>
                  </v-dialog> -->

                  <hr>
                  <br>
                  <v-flex xs12 sm12 lg12>      
                    <p class="form-titulo" >Resumo da proposta</p>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <div class="resumo">
                      <p style="margin-bottom: 0px;">Pet Titular</p>
                      <span class="subtotal">R$ {{valorTitular.replace('.',',')}}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 lg3>
                    <div class="resumo">
                      <p style="margin-bottom: 0px;">Pet Dependente(s)</p>
                      <span class="subtotal">R$ {{valorDependentes}}</span>
                    </div>
                  </v-flex>
                  <v-flex xs12 sm12 lg4>
                    <div class="resumo" v-if="planoSelecionado.taxaImplantacao != '0,00'">
                      <p style="margin-bottom: 0px;">Total a pagar + Taxa de Implantação</p>
                      <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>                  
                    </div>
                    <div class="resumo" v-else>
                      <p style="margin-bottom: 0px;">Total a pagar</p>
                      <span class="total">R$ {{valorTotalProposta.replace('.',',')}}</span>
                    </div>
                    <br>
                  </v-flex>
                  <v-flex xs12 sm12 lg12 v-if="planoSelecionado.taxaImplantacao != '0,00'">
                    <p style="font-weight:bolder">*Taxa de implantação única: R$ 4,00 por pet (Apenas na primeira mensalidade)</p> 
                  </v-flex>
                  <hr>
                  <br>
                  <v-layout row wrap justify-center id="asdasdasd" v-if="this.financialManagers.originRegister === 'INTERNO'">
                    <v-flex xs12 sm12 lg12>      
                      <p class="form-titulo">Dados do tutor</p>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        v-model="financialManagers.cpf"
                        label="CPF*"
                        v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpf')"
                        return-masked-value mask="###.###.###-##"
                        data-vv-name="cpf"
                        box
                        v-value="this.financialManagers.cpf"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        v-model="financialManagers.rg"
                        label="RG*"
                        v-validate="'required'"
                        :error-messages="errors.collect('rg')"
                        data-vv-name="rg"
                        box
                        v-value="this.financialManagers.rg"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>      
                      <v-text-field
                        v-model="financialManagers.rgEmitter"
                        label="Órgão Expedidor*"
                        v-validate="'required'"
                        :error-messages="errors.collect('rgEmissor')"
                        data-vv-name="rgEmissor"
                        box
                        v-value="this.financialManagers.rgEmitter"
                      ></v-text-field>
                    </v-flex>
                    <hr>
                  </v-layout>
                  <v-flex xs12 sm12 lg12>
                    <br v-if="this.financialManagers.originRegister === 'INTERNO'">
                    <p class="form-titulo">Pagamento</p>
                  </v-flex>
                  <v-flex xs12 sm12 lg3 v-if="informacaoOperadora('usaCupomDesconto')">
                    <v-text-field
                      v-model="financialManagers.cupomDesconto"
                      label="Cupom de desconto"
                      box
                      dense
                      :disabled="cupomAplicado"
                      color="#8395A7" 
                    ></v-text-field>
                  </v-flex>
                  <v-flex md12 xs12 sm12 lg3 v-if="informacaoOperadora('usaCupomDesconto')">
                    <v-btn  
                      style="border-radius: 8px;"
                      large                
                      dark
                      :disabled="cupomAplicado"
                      color="#8395A7"
                      @click="aplicaCupom()"
                    >Aplicar</v-btn>
                  </v-flex> 
                  <v-flex xs12 sm12 lg12 v-if="informacaoOperadora('usaCupomDesconto')">
                    <v-chip close v-model="cupomAplicado" color="teal" text-color="white">
                      <v-avatar>
                        <v-icon>check_circle</v-icon>
                      </v-avatar>
                      Cupom aplicado
                    </v-chip>
                  </v-flex>
                  <v-layout row wrap v-if="!financialManagers.reteveAdesao">
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'CARTAO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalCartao') && !planoSelecionado.anual">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Mensal Recorrente</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Mensal automático</h6>
                                <a @click="pagamentoCartao('mensal')" class="button">Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>  
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualParcelado') && planoSelecionado.anual) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualParcelado') && planoSelecionado.anual)">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual Parcelado</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{(parseFloat(valorTotalProposta - (this.planoSelecionado.descontoAvista * dependentes.length))*12).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Em até 12x de R$ {{((parseFloat(valorTotalProposta - (this.planoSelecionado.descontoAvista * dependentes.length))*12)/12).toFixed(2).replace('.', ',')}}</h6>
                                <a @click="pagamentoCartao('anualParcelado')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualCartao') && planoSelecionado.anual) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualCartao') && planoSelecionado.anual)">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual à Vista</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{parseFloat(valorTotalPropostaComDesconto * 12).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 v-if="this.planoSelecionado.descontoAnual > 0" class="desconto" style="text-align: center;">Desconto especial de {{this.planoSelecionado.descontoAnual}}%</h6>
                                <a @click="pagamentoCartao('anual')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'BOLETO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalBoleto')  && !planoSelecionado.anual">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Primeira parcela</h6>
                                <a @click="pagamentoBoleto('mensal')" class="button">Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>  
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualBoleto') && planoSelecionado.anual) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualBoleto')  && planoSelecionado.anual)">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Plano Anual</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{parseFloat(valorTotalPropostaComDesconto * 12).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 v-if="this.planoSelecionado.descontoAnual > 0" class="desconto" style="text-align: center;">Desconto especial de {{this.planoSelecionado.descontoAnual}}%</h6>
                                <a @click="pagamentoBoleto('anual')" class="button" >Gerar Boleto</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>             
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap v-else>
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'CARTAO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalCartao') && !planoSelecionado.anual">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Mensal Recorrente</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Mensal automático</h6>
                                <a @click="pagamentoCartao('mensal')" class="button">Enviar dados</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualCartao') && planoSelecionado.anual) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualCartao') && planoSelecionado.anual)">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">                    
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual à Vista</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{ ((parseFloat(valorTotalProposta.replace(',', '.')) - valorDesconto) * 11).toFixed(2).replace('.', ',') }}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Desconto especial</h6>
                                <a @click="pagamentoCartao('anual')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                        <v-flex xs12 sm12 lg4 v-if="(cupomAdesao && informacaoOperadora('usaPagamentoAnualParcelado') && planoSelecionado.anual) || (!cupomAdesao && informacaoOperadora('usaPagamentoAnualParcelado') && planoSelecionado.anual)">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center; color: #7fa761">Anual Parcelado</h6>
                                <br>
                                <p class="price" style="color: #7fa761"><span>R$</span> {{(parseFloat(valorTotalProposta - (this.planoSelecionado.descontoAvista * dependentes.length))*11).toFixed(2).replace('.', ',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Em 11x de R$ {{(parseFloat(valorTotalProposta - (this.planoSelecionado.descontoAvista * dependentes.length))).toFixed(2).replace('.', ',')}}</h6>
                                <a @click="pagamentoCartao('anualParcelado')" class="button" >Fazer Pagamento</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                        
                    <v-flex xs12 sm12 lg12 v-if="planoSelecionado.typePayment == 'BOLETO'">
                      <br>
                      <v-layout row wrap justify-center style="background-color:#dbe3e8;">
                        <v-flex xs12 sm12 lg4 v-if="informacaoOperadora('usaPagamentoMensalBoleto')  && !planoSelecionado.anual">
                          <div class="planos-wrapper" style="background-color:#dbe3e8;">
                            <div class="list-planos">
                              <div class="item">
                                <h6 class="form-titulo" style="text-align: center;">Plano Mensal</h6>
                                <br>
                                <p class="price"><span>R$</span> {{valorTotalProposta.replace('.',',')}}<br></p>
                                <br>
                                <h6 class="desconto" style="text-align: center;">Recorrente</h6>
                                <a @click="enviarProposta()" class="button">Enviar Proposta</a>
                              </div>
                            </div>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-stepper-content>
          <!-- FIM DO PASSO 5 -->
        </v-stepper-items>
      </v-stepper>

      <v-dialog v-model="dialogLoading" max-width="450px" max-height="300px" persistent> 
        <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
                <span class="total">Parabéns</span>              
              </v-card-title>
              <v-container fill-height fluid pa-1 justify-center class="resumo">
                <p class="resumo" style="text-align: center;">Sua proposta nº <span style="font-weight: 700;">{{financialManagers.proposalNumber}}</span> foi encaminhada para a {{informacaoOperadora("nome")}}. Você poderá acompanhar o andamento da sua Proposta na Área do Cliente.</p>
              </v-container>
              <v-flex xs10 sm10 lg10 v-if="planoSelecionado.typePayment == 'FUJIOKA'" style="background-color: #666">
                <p class="resumo" style="text-align: center; color: #fff"><b>AVISO: Seu contrato só estará ativo após a confirmação do RH</b></p>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-container fill-height fluid pa-1 justify-center>
                <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="confirmaContrato()">Fechar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- DIÁLOGO PARA ACEITAR O TERMO DE PRIVACIDADE -->
      <v-dialog v-model="dialogoAceiteTermo" max-width="700px" max-height="400px"> 
        <v-card>
          <v-container grid-list-md>
            <v-layout row wrap justify-center>
              <v-card-title>
                <span class="total">Prezado(a) cliente,</span>              
              </v-card-title>
              <v-container fluid pa-1 justify-center class="resumo">
                <p class="resumo" >Valorizamos a privacidade de seus dados. Por isso, investimos em modernidade nos nossos canais de comunicação, garantindo assim a segurança e a tranquilidade que você precisa.</p>
                <p class="resumo" >Por esse motivo, estamos enviando um termo de privacidade sobre os seus dados cadastrais.</p>
                <p class="resumo" >É necessário que você acesse nossa política de privacidade e aceite os termos para continuarmos recebendo e enviando suas informações.</p>
                <br>
                <p class="resumo" style="font-weight: bold">A <span style="color:#666">{{informacaoOperadora("nome")}}</span> agradece a sua atenção!</p>
                <p class="resumo" style="font-weight: bold">Vindo de você, tudo é importante!</p>
                <br>
                <p class="resumo" style="font-weight: bold;color:#666">Termo de Privacidade, <a href="https://maispetoficial.intelite.com.br/docs/Politica_de_Privacidade_MAIS_PET.pdf" target="_blank">clique aqui.</a></p>
                <v-checkbox v-model="checkboxTermoPrivacidade" color="#7e2985">
                  <span slot="label">Estou ciente e concordo com o Termo de Privacidade da {{informacaoOperadora("nome")}}.</span>
                </v-checkbox>
              </v-container>
            </v-layout>
            <v-card-actions>
              <v-container fill-height fluid pa-1 justify-center>
                <br>
                <v-btn @click="confirmaTermo()" color="#7e2985" depressed style="border-radius: 8px; width: 130px;color: white;">Continuar</v-btn>
              </v-container>
            </v-card-actions>
          </v-container>
        </v-card>
      </v-dialog>
    </section>
    <loading :active.sync="isLoading" :can-cancel="false" color="#8395A7" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import Snackbar from '../components/snackbar.vue'
  import axios from 'axios'
  import { baseApiUrl, modelBoleto, operadora, } from '@/global'
  import CpfValidate from '../components/validators/rules/cpf'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import vueCard from 'vue-card-express'
  import moment from 'moment'
  export default {
    components: {Snackbar, Loading, vueCard},
    data() {
      return {
        diaAtual: 0,
        dialogStep1: false,
        modal: false,
        dialog: false,
        idadeMinPlan: '',
        idadeMaxPlan: '',
        bancos: [{'value' : 'BRASIL' ,'text': 'Banco do Brasil'}],
        pagamentoTipoCartao: '',
        tipoPagamento: '',
        dadosCupom: [],
        aceitaBoleto: true,
        cupomAplicado: false,
        side: 1,
        token: '',
        idCostCenter:'',
        fullPage: true,  
        isLoading: false,  
        cartaValidado: false,        
        filesRg1: [],
        filesRg2: [],
        filesCPF: [],
        filesAddress: [],
        filesOutros: [], 
        anoValidade: ['2020','2021','2022','2023','2024','2025','2026','2027','2028','2029','2030','2031','2032','2033','2034','2035'],
        pegaDadosCartao: null,
        Anexos: {
          id: "ID_RESPONSAVEL_FINANCEIRO",
          imagesDocs: {
            cpf: "",
            rg: "",
            rg2: "",
            address: "",
            credtFrontal: "",
            physicalContract: "",
            adtive: "",
            others: ""
          }
        },
        rowsPerPageItems: [12, 18],
        pagination: {
          rowsPerPage: 12
        },
        exibeVendedor: true,
        linkParceriaIgrejas: false,
        linkParceriaAvanti: false,
        qtdDependentesInseridos: 0,
        pdfSelecionado: '',
        verificaTitularS4e: '',
        msgLoading: '',
        loading: false,
        financialManagUF: '',
        salaesSaudePet: '5cc0a27ee2cead066040bfc9',
        brokerSaudePet: '5cc0a118e2cead066040bfc6',
        contrataccept: false,
        contractAcceptComunicacoes: false,
        contractAcceptPoliticaPrivacidade: false,
        temVendedor: false,
        nomeVendedor: '',
        vendedorLink: [],
        vendedor: [],
        salesman: [],
        linkVendedor: false,
        cpfVendedor: '',
        inserirDepBloq: false,
        usarDadosFM: true,
        existeTitular: false,
        tipoTitular: false,
        radioBTtitular: true,
        alertTitular: false,
        editPassos: false,
        editaDadosPessoais: false,
        editaEndereco: false,
        editaPets: false,
        editedIndex: '',
        editedIndexTitular: '',
        valorDependentes: '0,00',
        valorDependentesComDesconto: '0,00',
        valorTotalProposta: '0,00',
        valorTotalPropostaComDesconto: '0,00',
        valorTitular: '0,00',
        valorDep1: '0,00',
        valorDep2: '0,00',
        valorDep3: '0,00',
        valorDep4: '0,00',
        valorTitularComDesconto: '0,00',
        valorDep1ComDesconto: '0,00',
        valorDep2ComDesconto: '0,00',
        valorDep3ComDesconto: '0,00',
        valorDep4ComDesconto: '0,00',
        valorFaixa: '0,00',
        valorPlano: '0,00',
        search: '',
        dialogDelete: false,
        dialogLoading: false,
        dialogCartao: false,
        checkboxTermoPrivacidade: false,
        dialogoAceiteTermo: false,
        dependentes: [], 
        dependentesCarregados: [],
        AtualFinancialManagers: [],
        e1: 0,
        bairro: '',
        cidade: '',
        estado: '',
        estados: [],
        parentesco: [  
          { value: 'CÔNJUGE', text: "CÔNJUGE" },
          { value: 'FILHO', text: "FILHO(A)" },
          { value: 'PAI/MÃE', text: "PAI/MÃE" },
          { value: 'AGREGADO', text: "IRMÃO(A)" },
          { value: 'AGREGADO', text: "SOBRINHO(A)" },
          { value: 'AGREGADO', text: "NETO(A)" } 
        ],
        generos: [
          { value: 1, text: "Masculino" },
          { value: 0, text: "Feminino" }
        ],
        bandeiras: [
          { value: 'DINERS', text: "DINERS" },
          { value: 'ELO', text: "ELO" },
          { value: 'HIPERCARD', text: "HIPERCARD" },
          { value: 'MASTERCARD', text: "MASTERCARD" },
          { value: 'VISA', text: "VISA" }
        ],
        generosPet: [
          { value: 1, text: "Macho" },
          { value: 0, text: "Fêmea" }
        ],
        especiePet: [
          { value: 1, text: "Cão" },
          { value: 2, text: "Gato" }
        ],
        especies: [],
        racaCao: [
          { value: 88, text: "ANGORÁ" },
          { value: 89, text: "BRACO HUNGARO" },
          { value: 95, text: "CANE CORSO" },
          { value: 91, text: "COTON DE TULEAR" },
          { value: 28, text: "DOGUE ALEMÃO" },
          { value: 100, text: "FOXHOUND-AMERICANO" },
          { value: 93, text: "MARISCADA" },
          { value: 97, text: "MENICON" },
          { value: 87, text: "PASTOR MAREMANO" },
          { value: 64, text: "PINSCHER" },
          { value: 101, text: "PIT BULL" },
          { value: 43, text: "SHIH TZU" },
          { value: 92, text: "TERRIER BRASILEIRO" },
          { value: 90, text: "VIZSLA" },
          { value: 94, text: "WHIPPET" },
          { value: 15, text: "YORKSHIRE TERRIER" },
          // raca nova
          { value: 76, text: "AKITA" },
          { value: 81, text: "AMERICAN BULLY" },
          { value: 16, text: "AMERICAN STAFFORDSHIRE TERRIER" },
          { value: 98, text: "BASENJI" },
          { value: 1, text: "BASSET" },
          { value: 68, text: "BASSET HOUND" },
          { value: 17, text: "BEAGLE" },
          { value: 135, text: "BELGA MELINOIS" },
          { value: 126, text: "BERNASE" },
          { value: 18, text: "BICHON MALTÊS" },
          { value: 19, text: "BOBTAIL" },
          { value: 77, text: "BOIADEIRO AUSTRALIANO" },
          { value: 20, text: "BORDER COLLIE" },
          { value: 21, text: "BOSTON TERRIER" },
          { value: 22, text: "BOXER" },
          { value: 42, text: "BULDOGUE FRANCÊS" },
          { value: 69, text: "BULDOGUE INGLES" },
          { value: 23, text: "BULL TERRIER" },
          { value: 25, text: "BULLDOG" },
          { value: 24, text: "BULLMASTIFF" },
          { value: 99, text: "CAVALIER K.C.S" },
          { value: 26, text: "CHIHUAHUA" },
          { value: 66, text: "CHIP DOG" },
          { value: 3, text: "CHOW CHOW" },
          { value: 4, text: "COCKER SPANIEL" },
          { value: 133, text: "COCKER SPANIEL INGLÊS" },
          { value: 5, text: "DACHSHUND" },
          { value: 6, text: "DÁLMATA" },
          { value: 29, text: "DOGUE ARGENTINO" },
          { value: 85, text: "DOGUE DE BORDEAUX" },
          { value: 71, text: "FILA" },
          { value: 86, text: "FLAT COATED" },
          { value: 84, text: "FOX PAULISTINHA" },
          { value: 30, text: "FOX TERRIER" },
          { value: 27, text: "DOBERMANN" },
          { value: 31, text: "GOLDEN RETRIEVER" },
          { value: 132, text: "GOLDEN RETRIVIER" },
          { value: 32, text: "HUSKY SIBERIANO" },
          { value: 67, text: "IASA APSO" },
          { value: 75, text: "JACK RUSSELL" },
          { value: 11, text: "LABRADOR" },
          { value: 33, text: "LAIKA" },
          { value: 2, text: "LHASA APSO" },
          { value: 74, text: "LULU DA POMERANIA" },
          { value: 10, text: "MALTÊS" },
          { value: 82, text: "PAPILLON" },
          { value: 8, text: "PASTOR ALEMÃO" },
          { value: 34, text: "PASTOR BELGA" },
          { value: 79, text: "PASTOR BRANCO SUIÇO" },
          { value: 78, text: "PASTOR-DE-SHETLAND" },
          { value: 35, text: "PEQUINÊS" },
          { value: 36, text: "PERDIGUEIRO" },
          { value: 127, text: "PIT MONSTER" },
          { value: 37, text: "PITBULL" },
          { value: 80, text: "POINT INGLÊS" },
          { value: 9, text: "POODLE" },
          { value: 38, text: "PUG" },
          { value: 12, text: "ROTTWEILER" },
          { value: 62, text: "S.R.D" },
          { value: 70, text: "S.R.D" },
          { value: 134, text: "SAMOIEDA" },
          { value: 39, text: "SÃO BERNARDO" },
          { value: 63, text: "SCHNAUZER" },
          { value: 13, text: "SHAR-PEI" },
          { value: 83, text: "SHIBA INU" },
          { value: 44, text: "SPITZ ALEMÃO ANÃO- POMERANIA" },
          { value: 40, text: "STAFFORDSHIRE BULL TERRIER" },
          { value: 96, text: "TEXAS HEELER" },
          { value: 14, text: "WEIMARANER" },
          { value: 41, text: "WEST HIGHLAND WHITE TERRIER" },
        ],
        racaGato: [
          { value: 45, text: "Abissínio"},
          { value: 115, text: "American Shorthair"},
          { value: 88, text: "Angorá"},
          { value: 110, text: "Angorá Turco"},
          { value: 114, text: "Ashera"},
          { value: 47, text: "Bengal"},
          { value: 107, text: "Blue Russian"},
          { value: 111, text: "Bobtail Japonês"},
          { value: 117, text: "Bombaim"},
          { value: 118, text: "British Shorthair"},
          { value: 60, text: "Burmês"},
          { value: 119, text: "Burmilla"},
          { value: 108, text: "Chartreux"},
          { value: 120, text: "Cornish Rex"},
          { value: 91, text: "Coton de Tulear"},
          { value: 121, text: "Devon Rex"},
          { value: 116, text: "Exótico"},
          { value: 112, text: "Himalaia"},
          { value: 7, text: "Husky Siberiano"},
          { value: 50, text: "Korat"},
          { value: 105, text: "Maine Coon"},
          { value: 106, text: "Manês"},
          { value: 51, text: "Manx"},
          { value: 93, text: "Mariscada"},
          { value: 48, text: "Mau Egípcio"},
          { value: 97, text: "Menicon"},
          { value: 122, text: "Oriental"},
          { value: 54, text: "Persa"},
          { value: 64, text: "Pinscher"},
          { value: 55, text: "Ragdoll"},
          { value: 125, text: "Sagrado da Birmânia"},
          { value: 123, text: "Scottish Fold"},
          { value: 56, text: "Siamês"},
          { value: 104, text: "Singapura"},
          { value: 124, text: "Snowshoe"},
          { value: 57, text: "Somali"},
          { value: 113, text: "Sphynx"},
          { value: 102, text: "SRD"},
          { value: 109, text: "Van Turco"},
          { value: 94, text: "Whippet"},
          { value: 46, text: "AMERICAN SHORT HAIR" },
          { value: 59, text: "BALINÊS" },
          { value: 73, text: "EXÓTICA" },
          { value: 128, text: "GATO KORAT" },
          { value: 129, text: "GATO LARANJA" },
          { value: 73, text: "EXÓTICA" },
          { value: 49, text: "HIMALAIO" },
          { value: 61, text: "JAVANÊS" },
          { value: 52, text: "MUNCHKIN" },
          { value: 53, text: "PÊLO CURTO BRASILEIRO" },
          { value: 58, text: "TURKISH ANGORA" },
          { value: 142, text: "NORUEGUES DA FLORESTA" },
        ],
        estadoscivil: [
          { value: "SOLTEIRO", text: "Solteiro(a)" },
          { value: "CASADO", text: "Casado(a)" },
          { value: "VIÚVO", text: "Viúvo(a)" },
          { value: "DIVORCIADO", text: "Divorciado(a)" }
        ],
        qtdParcelas: [],
        planoSelecionado: [],
        planoDep1: [],
        planoDep2: [],
        planoDep3: [],
        planoDep4: [],
        planoTitular: [],
        Dep1: [],
        Dep2: [],
        Dep3: [],
        Dep4: [],
        Titular: [],
        valorDependnte: '',
        selecaoPlano: '',
        planos: [],
        dataNasc: '',
        dataNascDependent: '',
        dependents: {
          parentage: '',
          valuePlan: '',
          namePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: 'SOLTEIRO',
          cpf: '',
          motherName: 'Não Informado',
          susNumber: '',
          plansId: '',
        },
        defaultDependents: {
          parentage: '',
          valuePlan: '',
          lackOfCare: 1,
          rcaId: '',
          dateFirstPayment: '',
          isHolder: '',
          financialManagerId: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: '',
          maritalStatus: 'SOLTEIRO',
          cpf: '',
          motherName: 'Não Informado',
          susNumber: '',
          plansId: ''
        },
        financialManagers: {
          contratanteTitular: false,
          confirmPassword: '',
          password: '',
          rg: '',
          bancoDeb: '',
          contaDeb: '',
          agenciaDeb: '',
          rgEmitter: '',
          homePhone: '',
          cellPhone: '',
          cellPhone2: '',
          email: '',
          cep: '',
          address: '',
          addressType: '',
          addressTypeName: '',
          addressNumber: '',
          addressComplement: '',
          district: '',
          city: '',
          state: '',
          proposalNumber: '',
          contractNumberS4: '',
          responsibility: '',
          cardNumber: '',
          cardValidity: '',
          cardFlag: '',
          cardCvc: '',
          cardDayExpiration: 15,
          dateSignatureContract: '',
          formOfPaymentId: '',
          formOfPayment: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: null,
          maritalStatus: 'SOLTEIRO',
          cpf: '',
          motherName: 'Não Informado',
          susNumber: '',
          plansId: '',
          nsu: '',
          autorizacaoCodigo: '',
          paymentId: '',
          TypeFm: 'FISICA',
          protocoloCancelamento: '',
          vendedor: '',
          CPFVendedor: '',
          matricula: '',
          stageForm: 2,
          tempPassword: false,
          originRegister: 'EXTERNO',
          existSales: '',
          salesmanId: '5cc0a27ee2cead066040bfc9',
          brokerId: '5cc0a118e2cead066040bfc6',
          qtdDependentes: '',
          situacaoBoleto: '',
          modalidadePagamento: '',
          cidadeId: '',
          petSaudavel: true,
          codigoIndicador: '',
          cupomDesconto: '',
          reteveAdesao: false,
        },
        defaultfinancialManagers: {
          contratanteTitular: false,
          confirmPassword: '',
          password: '',
          rg: '',
          bancoDeb: '',
          contaDeb: '',
          agenciaDeb: '',
          rgEmitter: '',
          homePhone: '',
          cellPhone: '',
          cellPhone2: '',
          email: '',
          cep: '',
          address: '',
          addressType: '',
          addressTypeName: '',
          addressNumber: '',
          addressComplement: '',
          district: '',
          city: '',
          state: '',
          proposalNumber: 0,
          contractNumberS4: '',
          responsibility: '',
          cardNumber: '',
          cardValidity: '',
          cardFlag: '',
          cardCvc: '',
          cardDayExpiration: -1,
          dateSignatureContract: '',
          formOfPaymentId: '',
          formOfPayment: '',
          firstName: '',
          lastName: '',
          dateOfBirth: '',
          gender: null,
          maritalStatus: 'SOLTEIRO',
          cpf: '',
          motherName: 'Não Informado',
          susNumber: '',
          plansId: '',
          nsu: '',
          autorizacaoCodigo: '',
          paymentId: '',
          TypeFm: 'FISICA',
          protocoloCancelamento: '',
          vendedor: '',
          CPFVendedor: '',
          matricula: '',
          stageForm: 2,
          tempPassword: false,
          originRegister: 'EXTERNO',
          existSales: '',
          salesmanId: '5cc0a27ee2cead066040bfc9',
          brokerId: '5cc0a118e2cead066040bfc6',
          qtdDependentes: '',
          situacaoBoleto: '',
          modalidadePagamento: '',
          cidadeId: '',
          codigoIndicador: '',
          cupomDesconto: '',
          reteveAdesao: false,
        },
        validarEmail: true,
        validarDataNascTit: true,
        validarDataNascDep: true,
        idBoleto: '',
        Sales: {
          status: 'PAGAMENTO PENDENTE',
          fMIPConfirm: '',
          fMConfirm: '',
          salesmanIPConfirm: '',
          financialManagerId: '',
          salesmanId: '',
          brokerId: '',
          salesmanConfirm: '',
          paymentId: '',
          boletoId: '',
          nsu: '',
          autorizacaoCodigo: ''
        },
        validadeCartaoAno: '',
        modelCartao: {
          id: '',
          valor: '',
          tipoTransacao: 'A_VISTA',
          quantidadeParcelas: 12,
          comprador: {
            id: '',
            documentoNumero: '',
            documentoTipo: '1',
            email: '',
            nomeCompleto: '',
            primeiroNome: '',
            ultimoNome: '',
            enderecoLogradouro: '',
            enderecoNumero: '',
            enderecoComplemento: '',
            enderecoCep: '',
            enderecoBairro: '',
            enderecoCidade: '',
            enderecoEstado: '',
          },
          cartao: {
            numero: '',
            codigoSeguranca: '',
            nome: '',
            expiracaoAno: '',
            expiracaoMes: '',
            bandeira: ''
          }
        },
        defaltModelCartao: {
          id: '',
          valor: '',
          tipoTransacao: 'A_VISTA',
          quantidadeParcelas: 12,
          comprador: {
            id: '',
            documentoNumero: '',
            documentoTipo: '1',
            email: '',
            nomeCompleto: '',
            primeiroNome: '',
            ultimoNome: '',
            enderecoLogradouro: '',
            enderecoNumero: '',
            enderecoComplemento: '',
            enderecoCep: '',
            enderecoBairro: '',
            enderecoCidade: '',
            enderecoEstado: '',
          },
          cartao: {
            numero: '',
            codigoSeguranca: '',
            nome: '',
            expiracaoAno: '',
            expiracaoMes: '',
            bandeira: ''
          }
        },
        steppers: {
          default: 0,
          type: Number
        },
        formOfPayment: {
          costCenterId: '',
          dayInclusion: 0,
          type: ''
        },
        idUf: '',
        idUser: '',
        cupomVendedor: false,
        valorCupom: 0,
        tipoCupom: '',
        cupomAdesao: false,
        documentosPlano: [],
        dictionary: {
          custom: {
            uf: {
              required: () => 'Informe a UF',
            },
            firstName: {
              required: () => 'Informe nome e sobrenome', 
              regex: () => 'Informe nome e sobrenome'                    
            },
            firstNameDep: {
              required: () => 'Informe o nome do pet'
            },
            email: {
              required: () => 'Informe o Email',
              email: () => 'Informe um Email válido'
            },
            password: {
              required: () => 'Informe a Senha',
              confirmed: () => 'A senha não confere'
            },
            senha: {
              required: () => 'Informe a Senha'
            },
            dateOfBirth: {
              required: () => 'Informe a Data de Nascimento' ,
              date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
            dateOfBirthDep: {
              required: () => 'Se não souber, pode ser a data estimada',
              date_format: () => 'Informe uma data válida (dd/mm/aaaa)'
            },
            gender: {
              required: () => 'Informe o Sexo' 
            },
            genderDep: {
              required: () => 'Informe o Sexo' 
            },
            especieDep: {
              required: () => 'Informe a Espécie'
            },
            maritalStatus: {
              required: () => 'Informe o Estado Civil' 
            },
            maritalStatusDep: {
              required: () => 'Informe o Estado Civil' 
            },
            motherName:{
              required: () => 'Informe o nome da Mãe',
              regex: () => 'Informe nome e sobrenome'
            },
            motherNameDep:{
              required: () => 'Informe o nome da Mãe',
              regex: () => 'Informe nome e sobrenome'
            },
            cep:{
              required: () => 'Informe o CEP'
            },
            numero: {
              required: () => 'Informe o Número, caso não tenha informe 1'
            },
            parentage: {
              required: () => 'Informe o Parentesco'
            },
            cpfDep: {
              required:() => 'Informe o CPF'
            },
            nomeCompCartao: {
              required: () => 'Informe o Nome',                   
            },
            emailCartao: {
              required: () => 'Informe o Email',
              email: () => 'Informe um Email válido'
            },
            cpfCartao: {
              required:() => 'Informe o CPF'
            },
            priNomeCartao: {
              required:() => 'Informe o Primeiro Nome'
            },
            ultNomeCartao: {
              required:() => 'Informe o Último Nome'
            },
            cepCartao: {
              required: () => 'Informe o CEP'
            },
            ruaCartao: {
              required: () => 'Informe a Rua'
            },
            numeroCartao: {
              required: () => 'Informe o Número, caso não tenha informe 0'
            },
            bairroCartao: {
              required: () => 'Informe o Bairro'
            },
            cidadeCartao: {
              required: () => 'Informe a Cidade'
            },
            estadoCartao: {
              required: () => 'Informe o Estado'
            },
            numCartao: {
              required: () => 'Informe o número do cartão de crédito',
              credit_card:() => 'Número de Cartão Inválido'
            },
            bandeiraCartao: {
              required:() => 'Informe a bandeira'
            },
            nomeCartao: {
              required: () => 'Informe o nome'
            },
            codCartao: {
              required: () => 'Informe o código de segurança'
            },
            expiraCartaoMes: {
              required: () => 'Informe o mês de validade do cartão',
            },
            expiraCartaoAno: {
              required: () => 'Informe o ano de validade do cartão',
            },
            carteirinha: {
              required: () => 'Informe o número da carteirinha'
            },
            rg: {
              required: () => 'Informe o número do RG'
            },
            rgEmissor: {
              required: () => 'Informe o Órgão Expedidor do RG'
            },
            Celular: {
              required: () => 'Informe o número do Celular'
            },
            agenciaDeb: {
              required: () => 'Informe o número da Agência'
            },
            contaDeb: {
              required: () => 'Informe o número da Conta'
            },
            bancoDeb: {
              required: () => 'Informe o nome do Banco'
            },
            selecaoplan: {
              required: () => 'Necessário selecionar o plano'
            }               
          }
        }
      }
    },

    mounted : function() {
      //this.exibeTermoPrivacidade()
      if (sessionStorage.getItem('FinancialManager') != null) {
        this.continuaProposta()
        this.carregaDados()
      } else if (localStorage.getItem('planoSelecionado') != null) {
        this.planoSelecionado = JSON.parse(localStorage.getItem('planoSelecionado'))
        this.selecaoPlano = this.planoSelecionado.id
        this.dependents.namePlan = this.planoSelecionado.name
        this.pdfSelecionado = this.planoSelecionado.urlContrato
      } else {
        this.pegaParametrosUrl()
      }
      this.carregaDados()
      if (sessionStorage.getItem('Vendedor') != null) {
        this.vendedorLink = JSON.parse(sessionStorage.getItem('Vendedor'))
        this.temVendedor = true
        this.linkVendedor = true
        this.nomeVendedor = this.vendedorLink.linkSite
        this.financialManagers.vendedor = this.vendedorLink.linkSite
        this.financialManagers.CPFVendedor = this.vendedorLink.cpf.replace(/[^\d]+/g,'')
        this.financialManagers.salesmanId = this.vendedorLink.id  
        this.financialManagers.brokerId = this.vendedorLink.brokerId            
      }
      if (sessionStorage.getItem('indicacao') != null) {
        this.financialManagers.codigoIndicador = sessionStorage.getItem('indicacao')
      }
      this.$validator.localize('pt', this.dictionary)
      this.$store.dispatch('Logar')
      //this.valorTotalProposta = parseFloat(this.planoSelecionado.value) /* + parseFloat(this.valorTaxaImplantacao) */ 
      this.diaAtual = parseInt(moment().format('DD'))
    },

    watch: {
      dialog(val) {
        val || this.close()
      },

      cupomAplicado(val){
        if (val == false)
          this.excluiCupom()
      }
    },

    computed: {       
      formTitle() {
        return this.editedIndex === '' ? 'Incluir Pet' : 'Editar Pet'
      },

      formTitleTitular() {
        return this.editedIndexTitular === '' ? 'Incluir Pet Titular' : 'Editar Pet Titular'
      },

      filteredItems() {
        return this.racas.filter(raca => raca.especie.codeS4 === this.dependents.especie)
      },
    },

    methods: {
      informacaoOperadora(atributo) {
        return operadora[atributo]
      },

      confirmaTermo() {
        if (this.checkboxTermoPrivacidade) {
          this.dialogoAceiteTermo = false
        } else {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825", "Para continuar, é necessário concordar com os termos de privacidade!", "ATENÇÃO")
        }
      },

      exibeTermoPrivacidade(){
        if (this.e1 == 0) {
          this.dialogoAceiteTermo = true
        }
      },

      editItem(item) {
        this.editedIndex = item.id
        this.editedIndexTitular = item.id
        this.dependents = Object.assign({}, item)
        this.dataNascDependent = this.formatDateBrz(this.dependents.dateOfBirth)
        if (item.isHolder == true)
          this.tipoTitular = true
        else
          this.tipoTitular = false
        this.dialog = true
      },

      async continuaProposta() {
        this.isLoading = true
        if (sessionStorage.getItem('FinancialManager') != null) {
          this.financialManagers = JSON.parse(sessionStorage.getItem('FinancialManager') || '[]')
          //this.planoSelecionado = this.financialManagers.planoSelecionado
          this.idUser = this.financialManagers.id
          this.dataNasc = this.formatDateBrz(this.financialManagers.dateOfBirth)        
          if (!this.financialManagers.contratanteTitular && this.financialManagers.stageForm >= 6)
            this.existeTitular = true
          else
          this.existeTitular = false

          //Carrega as informações do Plano
          try {
            let res = await axios.post(`${baseApiUrl}FinancialManagers/proposta`, {"id": this.idUser})
            if (res.data != '') {
              this.planoSelecionado = res.data.plano
              this.pdfSelecionado = this.planoSelecionado.urlContrato
              this.selecaoPlano = this.financialManagers.plansId
            }
            if (this.planoSelecionado.typePayment == 'BOLETO')
              this.tipoPagamento = 'BOLETO'
            this.selecaoPlano = this.planoSelecionado.id
            this.dependents.namePlan = this.planoSelecionado.name  
            this.selecionaPlanoDepend()            
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar plano","ERRO");
          }

          //Carrega as informações do Vendedor
          if (this.financialManagers.vendedor != '') {
            try {
              let res = await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${this.financialManagers.vendedor}`) 
              if (res.data != '') {
                this.vendedorLink = res.data[0] 
                this.temVendedor = true
                this.linkVendedor = true
                this.nomeVendedor = this.vendedorLink.linkSite  
                this.financialManagers.salesmanId = this.vendedorLink.id  
                this.financialManagers.brokerId = this.vendedorLink.brokerId 
              }
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar dados do vendedor","ERRO");
            } 
          }
        
          // carregar endereço
          //this.retornoCEP()
          //Carrega estagio do Cadastro
          switch (this.financialManagers.stageForm) {
            case 2: 
              this.e1 = 2
              break;
            case 3:
              this.e1 = 3
              this.editaDadosPessoais = true
              break;
            case 4:
              await this.carregaDependentes()
              await this.carregaEspecieRacas()
              this.e1 = 4
              this.editaDadosPessoais = true
              this.editaEndereco = true
              break;
            case 5:
              this.editaDadosPessoais = true
              this.editaEndereco = true
              this.editaPets = true
              await this.carregaDependentes()
              this.e1 = 5
              break;
            case 6:
              this.editaDadosPessoais = true
              this.editaEndereco = true
              this.editaPets = true
              await this.carregaDependentes()
              await this.avancaPasso6()               
              break;
            default:
              break;
          }
          this.isLoading = false
        }
      },

      async deleteDependente() {
        await axios.delete(`${baseApiUrl}Dependents/${this.editedIndex}`)
        .then(() => {    
          this.carregaDependentes()
          this.close()                
        }).catch(() => {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao excluir pet dependente","ERRO");              
          this.close()
        })
      },

      async carregaDados() {
        this.$validator.localize('pt', this.dictionary)
        await axios.get(`${baseApiUrl}UFs`).then(res => {        
          if (res.data != null) {
            this.estados = res.data
          }
        })
        try {
          this.planos = []
          let res = await axios.get(`${baseApiUrl}Plans?filter[where][typePayment]=${this.planoSelecionado.typePayment}`)
          for (var key in res.data) {
            if (res.data[key].abrangenciaId) {
              if (res.data.hasOwnProperty(key)) {
                this.planos.push({
                  'codeS4': res.data[key].codeS4,                  
                  'familyTable': res.data[key].familyTable,
                  'id': res.data[key].id,
                  'name': res.data[key].name,                   
                  'value': res.data[key].value,
                  'descricao': res.data[key].name + " - R$" + res.data[key].value,
                  'idadeMinima': res.data[key].idadeMinima,
                  'idadeMaxima': res.data[key].idadeMaxima,
                });
              }
            }
          }
        } catch (error) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao consultar os planos","ERRO");
        }
      },

      selecionaPlanoDepend() {
        /* this.selecaoPlano = this.planoSelecionado.id
        this.dependents.plansId = this.planoSelecionado.id
        this.dependents.valuePlan = this.planoSelecionado.value
        this.dependents.namePlan = this.planoSelecionado.name 
        this.idadeMinPlan = this.planoSelecionado.idadeMinima           
        this.idadeMaxPlan = this.planoSelecionado.idadeMaxima */
        for (var i = 0; i < this.planos.length; i++) {
          if (this.planos[i].id === this.selecaoPlano) {
            this.dependents.plansId = this.planos[i].id
            this.dependents.valuePlan = this.planos[i].value
            this.dependents.namePlan = this.planos[i].name
            this.idadeMinPlan = this.planos[i].idadeMinima           
            this.idadeMaxPlan = this.planos[i].idadeMaxima
          }
        }
        if (this.calculateAge(this.formatDate(this.dataNascDependent)) >= this.idadeMinPlan && this.calculateAge(this.formatDate(this.dataNascDependent)) <= this.idadeMaxPlan )
          return true
        else
          return false
      },

      async salvarPrimeiroAcesso() {
        await this.$validator.validate('email').then(valid => {
          if (!valid)
            this.validarEmail = false
          else
            this.validarEmail = true
        });

        if (this.financialManagers.email == '' || this.financialManagers.firstName == '' || this.financialManagers.password == '' || this.financialManagers.cpf == '' || this.financialManagers.confirmPassword == '' || this.financialManagers.cellPhone == '' || this.financialManagers.password != this.financialManagers.confirmPassword || !this.validarEmail)
          this.$validator.validateAll()
        else {   
          this.isLoading = true 
          var verificaemail = ''
          var verificaCancelamento
          await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"email": this.financialManagers.email}).then(res => {         
            if (res.data != '') {
              verificaemail = res.data.email
              verificaCancelamento = res.data.protocoloCancelamento  
            }              	
          })
          if (verificaemail == '' || verificaCancelamento != '') {
            //this.financialManagers.planoSelecionado = this.planoSelecionado 
            this.financialManagers.plansId = this.planoSelecionado.id 
            this.financialManagers.firstName = this.financialManagers.firstName.toUpperCase()
            this.financialManagers.email = this.financialManagers.email.toLowerCase()               
            if (this.planoSelecionado.typePayment == 'FUJIOKA') {
              this.financialManagers.salesmanId = this.planoSelecionado.salesmanIdDefaut 
              this.financialManagers.brokerId = this.planoSelecionado.brokerIdDefault
            }
            await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers).then(res => {         
              if (res.data != '') {
                this.idUser = res.data.id
                this.financialManagers.id = res.data.id
                this.$validator.reset()
                this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 6)+Math.floor(1000 + Math.random() * 1000)
                this.financialManagers.stageForm = 2
                this.e1 = 2   
                this.salvarFinancialManager()
                this.isLoading = false                 
              }              	
            })
          } else {
            this.isLoading = false
            // var vm = this;
            // vm.$refs.chamaSnackbar.snack("#F9A825","Já existe um cadastro para esse email, acesse a Área do Cliente!","ATENÇÃO")
            this.dialogStep1 = true
          }
        }
      },

      async avancaPasso3() {
        await this.$validator.validate('dateOfBirth').then(valid => {
          if (!valid)
            this.validarDataNascTit = false
          else
            this.validarDataNascTit = true
        });
        if (this.dataNasc == '' || this.financialManagers.gender == null || this.financialManagers.cpf == '' || !CpfValidate(this.financialManagers.cpf) || this.financialManagers.rg == '' || this.financialManagers.rgEmitter == '' || !this.validarDataNascTit)
          this.$validator.validateAll()
        else {  
          this.isLoading = true
          await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {
            if (Object.keys(res.data).length > 0) {
              res.data.Data.forEach( (titular) => {
                if (titular.Dependente[0].Situacao == "1") {
                  this.verificaTitularS4e = true
                } else {
                  this.verificaTitularS4e = false
                }
              })
            } else {
              this.verificaTitularS4e = false
            }
          })
          this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
          await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers)
          .then(res => { 
            if (res.data != '') {
              if (this.financialManagers.contratanteTitular && !this.verificaTitularS4e) {
                this.dependents.valuePlan = this.planoSelecionado.value
                this.dependents.rcaId = '8'
                this.dependents.dateFirstPayment = moment().add(1, 'M').format('YYYYMM')
                this.dependents.isHolder = true
                this.dependents.financialManagerId = this.idUser
                this.dependents.firstName = this.financialManagers.firstName
                this.dependents.dateOfBirth = this.financialManagers.dateOfBirth
                this.dependents.gender = this.financialManagers.gender
                this.dependents.especie = this.financialManagers.especie
                this.dependents.raca = this.financialManagers.raca
                this.dependents.maritalStatus = this.financialManagers.maritalStatus
                this.dependents.cpf = this.financialManagers.cpf
                this.dependents.motherName = this.financialManagers.motherName
                this.dependents.plansId = this.planoSelecionado.id
                this.salvarTitular()
                this.financialManagers.stageForm = 3
                this.e1 = 3
                this.editaDadosPessoais = true
                this.editaEndereco = false
                this.editaPets = false
                this.isLoading = false
                this.alertTitular = false
                this.radioBTtitular = false
                this.$validator.reset()
              } else if(!this.financialManagers.contratanteTitular) {
                this.e1 = 3
                this.editaDadosPessoais = true
                this.financialManagers.stageForm = 3
                this.isLoading = false
                this.alertTitular = !this.financialManagers.contratanteTitular
                this.radioBTtitular = false
                this.$validator.reset()
              } else {
                this.isLoading = false
                var vm2 = this;
                vm2.$refs.chamaSnackbar.snack("#F9A825","Não foi possível incluir o Titular, já existe um contrato ativo para esse CPF!","ATENÇÃO")
              }
            }
          })
          await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser})
          .then(res => {
            if (res.data != '') {
              this.existeTitular = true
              this.alertTitular = false
            }
          })
        }
      },

      async salvarFinancialManager() {
        try {
          let res = await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers ) 
          if (res.data != '') {
            //
          }              
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
        }
      },

      async avancaPasso5() {
        if (this.financialManagers.cep == '' || this.financialManagers.addressNumber == null || this.financialManagers.address == '' || this.financialManagers.city == '' || this.financialManagers.state == '' || this.financialManagers.district == '')
          this.$validator.validateAll()
        else {            
          this.isLoading = true
          await this.carregaEspecieRacas()
          //SALVA OS DEPENDENTES QUE FORAM CARREGADOS
          // if(this.qtdDependentesInseridos < this.financialManagers.qtdDependentes)
          // this.salvarDependentesCarregados()
          this.financialManagers.stageForm = 4 
          this.salvarFinancialManager()
          this.carregaDependentes()
          setTimeout(() => {            
            this.e1 = 4
            this.editaEndereco = true
            this.isLoading = false
          }, 2000);
          this.$validator.reset()                
          if (this.financialManagers.contratanteTitular == false && this.existeTitular == false) {
            if (this.planoSelecionado.typePayment == 'BOLETO')
              this.tipoPagamento = 'BOLETO'
            else if (this.planoSelecionado.typePayment == 'CARTAO')
              this.tipoPagamento = 'CARTAO'
            else if (this.planoSelecionado.typePayment == 'FUJIOKA')
              this.tipoPagamento = 'FUJIOKA'
              // this.selecionaPlanoDepend()
              this.carregaDados()
              this.openDialog()
          }                        
        }
      },

      async avancaPasso6() {
        if (this.alertTitular) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário informar o Titular do Plano!","ATENÇÃO")
        } /* else if (this.planoSelecionado.qualificacao.toUpperCase().includes('FAMILIAR') && this.qtdDependentesInseridos < 2 && this.financialManagers.matricula == '' && this.planoSelecionado.area_atuacao != 'AVANTI/PALMEIRAS' && this.planoSelecionado.area_atuacao != 'IGREJAS SP') {
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack("#F9A825","Para planos do tipo 'FAMILIAR' é necessário incluir pelo menos um dependente","ATENÇÃO")
        }  */         
        else {  
          this.isLoading = true 
          /* if(this.financialManagers.originRegister == 'INTERNO') {
            this.valorTotalProposta = this.financialManagers.responsibility
            this.exibeVendedor = false      
          } else {
            this.exibeVendedor = true              
            this.financialManagers.responsibility = this.valorTotalProposta
          } */
          this.financialManagers.stageForm = 5
          this.salvarFinancialManager()
          //this.enviaAnexos()
          this.e1 = 5
          this.editaPets = true
          this.isLoading = false            
        }
        //Pegando codeS4 para salvar no FinancialManager
        try {
          let res = await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${this.financialManagers.state}}}`) 
          if (res.data != '') {
            this.financialManagUF = res.data[0].prefix
            this.idUf = res.data[0].id
          }              
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro consultar o Estado do cliente","ERRO");
        }
        /* await axios.get(`${baseApiUrl}UFs?filter={"where":{"codeS4":${this.financialManagers.state}}}`).then(res => {
          if (res.data != null) {
            this.financialManagUF = res.data[0].prefix
            this.idUf = res.data[0].id
          }
        })  */

        //pegando o ID o centro de custo
        this.pegarCostCenterUf()

        //obtendo os documentos dos planos
        this.dependentes.forEach(async dependente => {
          await this.pegaDocumentos(dependente.plansId)
        })
      },

      //Pega o centro de custo pelo idUf
      async pegarCostCenterUf() {
        try {
          let res = await axios.get(`${baseApiUrl}CostCenters?filter[where][ufId]=${this.idUf}`) 
          if (res.data != '') {
            this.idCostCenter = res.data[0].id
          }              
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro consultar o centro de custo","ERRO");
        }
      },

      async pegaDocumentos(idPlano) {
        await axios.get(baseApiUrl + 'Plans/' + idPlano + '?filter={"fields":{"name":true,"urlContrato":true,"urlCobertura":true,"id":true}}')
        .then(response => {
          if (response.data) {
            if (this.documentosPlano.length == 0) {
              this.documentosPlano.push(response.data)
            } else {
              for (let i = 0; i < this.documentosPlano.length; i++) {
                if (response.data.id != this.documentosPlano[i].id) {
                  this.documentosPlano.push(response.data)
                }
              }
            }
          }
        }).catch(() => {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar planos","DESCULPE");
        })
      },

      async verificaTitular() {
        await axios.post(`${baseApiUrl}APIS4s/Associados`, {"cpf": this.financialManagers.cpf.replace(/\D/g, ''),"empresa": 0,"incluirDependentes":1}).then(res => {         
          if (res.data.Data.length > 0)
            this.verificaTitularS4e = true 
          else
            this.verificaTitularS4e = false         	
        })
      },

      async salvarContinuar() {
        this.financialManagers.dateOfBirth = this.formatDate(this.dataNasc)
        this.financialManagers.stageForm = this.e1
        await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers).then(res => {         
          if (res.data != '') {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#0288D1","Informações salvas com sucesso, para continuar depois, acesse a Área do Cliente!","INFORMAÇÃO")
          }
        })
      },

      formatDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },

      formatDateBrz (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDateCartao (date) {
        if (!date) return null
        const [year, month] = date.split('-')
        return `${month}/${year}`
      },

      async retornoCEP() {
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
          try {
            let res = await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.financialManagers.cep}) 
            if (res.data != '') {
              this.financialManagers.address = res.data.Logradouro
              this.cidade = res.data.Municipio
              this.financialManagers.city = res.data.IdMunicipio
              this.estado = res.data.Uf
              this.financialManagers.state = res.data.IdUf
              this.bairro = res.data.Bairro
              this.financialManagers.district = res.data.IdBairro
              this.financialManagers.addressType = res.data.IdTipoLogradouro
              this.financialManagers.addressTypeName = res.data.TipoLogradouro
            } else {
              var vmcep = this;
              vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.financialManagers.address = ''
              this.cidade = ''
              this.financialManagers.city = ''
              this.estado = ''
              this.financialManagers.state = ''
              this.bairro = ''
              this.financialManagers.district = ''
              this.financialManagers.addressType = '' 
            }             
          } catch (error) {
            vmcep = this;
            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
            this.financialManagers.address = ''
            this.cidade = ''
            this.financialManagers.city = ''
            this.estado = ''
            this.financialManagers.state = ''
            this.bairro = ''
            this.financialManagers.district = ''
            this.financialManagers.addressType = '' 
          }
        }           
      },

      async retornoCEPcartao(){
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.modelCartao.comprador.enderecoCep)) {
          axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.modelCartao.comprador.enderecoCep}).then(res => {        
            if (res.data != null) {
              this.modelCartao.comprador.enderecoLogradouro = res.data.Logradouro
              this.modelCartao.comprador.enderecoCidade = res.data.Municipio
              this.modelCartao.comprador.enderecoEstado = res.data.Uf
              this.modelCartao.comprador.enderecoBairro = res.data.Bairro
            } else {
              var vmcepcart = this;
              vmcepcart.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
              this.modelCartao.comprador.enderecoLogradouro = ''
              this.modelCartao.comprador.enderecoCidade = ''
              this.modelCartao.comprador.enderecoEstado = ''
              this.modelCartao.comprador.enderecoBairro = ''
            }
          })
        }
      },
        
      async retornoViaCEP(){
        if (/^[0-9]{5}-[0-9]{3}$/.test(this.financialManagers.cep)) {
          try {
            let res = await axios.get(`https://viacep.com.br/ws/${this.financialManagers.cep.replace(/[^\d]+/g,'')}/json/`) 
            if (res.data.erro == true || res.data.bairro == '' || res.data.localidade == '' || res.data.uf == '') {
              this.retornoCEP()
            } else {
              this.cidade = res.data.localidade
              this.financialManagUF = res.data.uf
              this.bairro = res.data.bairro
            }             
          } catch (error) {
            var vmcep = this;
            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
            this.cidade = ''
            this.financialManagUF = ''
            this.bairro = ''
          }
        }        
      },

      async consultaVendedor() {
        if (CpfValidate(this.cpfVendedor)) {
          await axios.get(`${baseApiUrl}Salesmans?filter[where][cpf]=${this.cpfVendedor}`).then(res => {        
            if (res.data != '') {
              this.vendedorLink = res.data[0] 
              this.temVendedor = true
              //this.linkVendedor = true
              this.nomeVendedor = this.vendedorLink.linkSite 
              this.financialManagers.salesmanId = this.vendedorLink.id  
              this.financialManagers.brokerId = this.vendedorLink.brokerId             
            } else {
              var vmcpfvend = this;
              vmcpfvend.$refs.chamaSnackbar.snack("#F9A825","Vendedor não localizado","ATENÇÃO");
              this.nomeVendedor = ''
            }
          })
        }
      },

      async carregaDependentes() {
        // this.valorFaixa = parseFloat(this.planoSelecionado.value.replace(',', '.')).toFixed(2)
        // this.valorPlano = this.planoSelecionado.value
        //this.valorDependnte = '0,00'
        var count = 0
        // var taxa = 0
        try {
          let res = await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser})
          if (res.data != null) {
            this.dependentes = res.data.dependentes           
            this.qtdDependentesInseridos = this.dependentes.length
            if (this.dependentes.length == 1) {
              this.valorDependentes = '0,00'
              this.valorDependnte = this.valorTitular
            }
            
            for (let index = 0; index < this.dependentes.length; index++) {
              count++
              // verifica se o beneficiário não é titular
              if (!this.dependentes[index].isHolder) {
                let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.dependentes[index].plansId}`)
                if (res.data != null) {
                  switch (count) {
                    case 2:
                      this.planoDep1 = res.data[0]
                      this.Dep1 = this.dependentes[1]
                      break;
                    case 3:
                      this.planoDep2 = res.data[0]
                      this.Dep1 = this.dependentes[1]
                      this.Dep2 = this.dependentes[2]
                      break;
                    case 4:
                      this.planoDep3 = res.data[0]
                      this.Dep1 = this.dependentes[1]
                      this.Dep2 = this.dependentes[2]
                      this.Dep3 = this.dependentes[3]
                      break;
                    case 5:
                      this.planoDep4 = res.data[0]
                      this.Dep1 = this.dependentes[1]
                      this.Dep2 = this.dependentes[2]
                      this.Dep3 = this.dependentes[3]
                      this.Dep4 = this.dependentes[4]
                      break;
                    default:
                      break;
                  }
                }
              } else {
                let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${this.dependentes[index].plansId}`)
                if (res.data != null) {
                  this.planoTitular = res.data[0]
                  this.Titular = this.dependentes[0]
                  this.pdfSelecionado = this.planoTitular.urlContrato
                }
              }
            } 
          }
          //Trata faixa de usuários
          if (count == 1) {
            this.valorTitular = this.planoTitular.value
            this.Titular.valuePlan = this.valorTitular
            this.atualizaValorPlanoDep(this.Titular)
          } else if (count == 2) {
            this.valorTitular = this.planoTitular.familyTable.value2
            this.valorDep1 = this.planoDep1.familyTable.value2
            this.valorDep1ComDesconto = parseFloat(this.valorDep1.replace(",",".") - ((this.valorDep1.replace(",",".") * this.planoDep1.descontoAnual) / 100)).toFixed(2)
            this.valorDependentes = (parseFloat(this.valorDep1.replace(',','.'))).toFixed(2)
            this.valorDependentesComDesconto = parseFloat(this.valorDep1ComDesconto.replace(",",".")).toFixed(2)
            this.Titular.valuePlan = this.valorTitular
            this.Dep1.valuePlan = this.valorDep1
            this.atualizaValorPlanoDep(this.Titular)
            this.atualizaValorPlanoDep(this.Dep1)
          } else if (count == 3) {
            this.valorTitular = this.planoTitular.familyTable.value3
            this.valorDep1 = this.planoDep1.familyTable.value3
            this.valorDep2 = this.planoDep2.familyTable.value3
            this.valorDep1ComDesconto = parseFloat(this.valorDep1.replace(",",".") - ((this.valorDep1.replace(",",".") * this.planoDep1.descontoAnual) / 100)).toFixed(2)
            this.valorDep2ComDesconto = parseFloat(this.valorDep2.replace(",",".") - ((this.valorDep2.replace(",",".") * this.planoDep2.descontoAnual) / 100)).toFixed(2)
            this.valorDependentes = (parseFloat(this.valorDep1.replace(',','.')) + parseFloat(this.valorDep2.replace(',','.'))).toFixed(2)
            this.valorDependentesComDesconto = (parseFloat(this.valorDep1ComDesconto.replace(",",".")) + parseFloat(this.valorDep2ComDesconto.replace(",","."))).toFixed(2)
            this.Titular.valuePlan = this.valorTitular
            this.Dep1.valuePlan = this.valorDep1
            this.Dep2.valuePlan = this.valorDep2
            this.atualizaValorPlanoDep(this.Titular)
            this.atualizaValorPlanoDep(this.Dep1)
            this.atualizaValorPlanoDep(this.Dep2)
          } else if (count == 4) {
            this.valorTitular = this.planoTitular.familyTable.value4
            this.valorDep1 = this.planoDep1.familyTable.value4
            this.valorDep2 = this.planoDep2.familyTable.value4
            this.valorDep3 = this.planoDep3.familyTable.value4
            this.valorDep1ComDesconto = parseFloat(this.valorDep1.replace(",",".") - ((this.valorDep1.replace(",",".") * this.planoDep1.descontoAnual) / 100)).toFixed(2)
            this.valorDep2ComDesconto = parseFloat(this.valorDep2.replace(",",".") - ((this.valorDep2.replace(",",".") * this.planoDep2.descontoAnual) / 100)).toFixed(2)
            this.valorDep3ComDesconto = parseFloat(this.valorDep3.replace(",",".") - ((this.valorDep3.replace(",",".") * this.planoDep3.descontoAnual) / 100)).toFixed(2)
            this.valorDependentes = (parseFloat(this.valorDep1.replace(',','.')) + parseFloat(this.valorDep2.replace(',','.')) + parseFloat(this.valorDep3.replace(',','.'))).toFixed(2)
            this.valorDependentesComDesconto = (parseFloat(this.valorDep1ComDesconto.replace(",",".")) + parseFloat(this.valorDep2ComDesconto.replace(",",".")) + parseFloat(this.valorDep3ComDesconto.replace(",","."))).toFixed(2)
            this.Titular.valuePlan = this.valorTitular
            this.Dep1.valuePlan = this.valorDep1
            this.Dep2.valuePlan = this.valorDep2
            this.Dep3.valuePlan = this.valorDep3
            this.atualizaValorPlanoDep(this.Titular)
            this.atualizaValorPlanoDep(this.Dep1)
            this.atualizaValorPlanoDep(this.Dep2)
            this.atualizaValorPlanoDep(this.Dep3)
          } else if (count == 5) {
            this.valorTitular = this.planoTitular.familyTable.value5
            this.valorDep1 = this.planoDep1.familyTable.value5
            this.valorDep2 = this.planoDep2.familyTable.value5
            this.valorDep3 = this.planoDep3.familyTable.value5
            this.valorDep4 = this.planoDep4.familyTable.value5
            this.valorDep1ComDesconto = parseFloat(this.valorDep1.replace(",",".") - ((this.valorDep1.replace(",",".") * this.planoDep1.descontoAnual) / 100)).toFixed(2)
            this.valorDep2ComDesconto = parseFloat(this.valorDep2.replace(",",".") - ((this.valorDep2.replace(",",".") * this.planoDep2.descontoAnual) / 100)).toFixed(2)
            this.valorDep3ComDesconto = parseFloat(this.valorDep3.replace(",",".") - ((this.valorDep3.replace(",",".") * this.planoDep3.descontoAnual) / 100)).toFixed(2)
            this.valorDep4ComDesconto = parseFloat(this.valorDep4.replace(",",".") - ((this.valorDep4.replace(",",".") * this.planoDep4.descontoAnual) / 100)).toFixed(2)
            this.valorDependentes = (parseFloat(this.valorDep1.replace(',','.')) + parseFloat(this.valorDep2.replace(',','.')) + parseFloat(this.valorDep3.replace(',','.')) + parseFloat(this.valorDep4.replace(',','.'))).toFixed(2)
            this.valorDependentesComDesconto = (parseFloat(this.valorDep1ComDesconto.replace(",",".")) + parseFloat(this.valorDep2ComDesconto.replace(",",".")) + parseFloat(this.valorDep3ComDesconto.replace(",",".")) + parseFloat(this.valorDep4ComDesconto.replace(",","."))).toFixed(2)
            this.Titular.valuePlan = this.valorTitular
            this.Dep1.valuePlan = this.valorDep1
            this.Dep2.valuePlan = this.valorDep2
            this.Dep3.valuePlan = this.valorDep3
            this.Dep4.valuePlan = this.valorDep4
            this.atualizaValorPlanoDep(this.Titular)
            this.atualizaValorPlanoDep(this.Dep1)
            this.atualizaValorPlanoDep(this.Dep2)
            this.atualizaValorPlanoDep(this.Dep3)
            this.atualizaValorPlanoDep(this.Dep4)
          }
          if (this.cupomAplicado) {
            if (this.dadosCupom.dados.tipoDesconto == 'ADESÃO') {
              this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
              this.valorTotalPropostaComDesconto = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentesComDesconto.replace(',','.'))).toFixed(2)
            } else {
              this.valorTotalPropostaComDesconto = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
            }
          } else {
            this.valorTitularComDesconto = parseFloat(this.valorTitular.replace(",",".") - ((this.valorTitular.replace(",",".") * this.planoTitular.descontoAnual) / 100)).toFixed(2)
            this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
            this.valorTotalPropostaComDesconto = (parseFloat(this.valorTitularComDesconto.replace(',','.')) + parseFloat(this.valorDependentesComDesconto.replace(',','.'))).toFixed(2)
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao carregar os dependentes","ERRO") 
        }

        //Verifica se existe titular
        if (this.dependentes.length > 0) {
          this.alertTitular = false
          this.existeTitular = true 
        } else {
          this.alertTitular = true
          this.existeTitular = false 
        }
      },

      async carregaFinancialManagers(){
        await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser})
        .then(res => {        
          if (res.data != null) {
            this.AtualFinancialManagers = res.data.financialManager
          }
        })
      },

      async salvarTitular() { 
        //this.existeTitular = false
        await axios.post(baseApiUrl + 'FinancialManagers/proposta', {"id": this.idUser})
        .then(res => {
          if (res.data != '') {
            this.existeTitular = true              
          }
        }) 
        if (!this.existeTitular) {
          await axios.post(baseApiUrl + 'Dependents/editaDependente', this.dependents).then(res => {         
            if (res.data != '') {
              //this.carregaDependentes()     
            }              	
          })
        }
      },

      async aplicaCupom() {
        if (this.financialManagers.cupomDesconto != '') {
          var vm = this;
          this.isLoading = true
          try {
            let res = await axios.post(`${baseApiUrl}Cupons/check`, {"cupom":this.financialManagers.cupomDesconto})
            this.dadosCupom = res.data
            if (this.dadosCupom.dados == null) {
              this.isLoading = false
              vm.$refs.chamaSnackbar.snack("#F9A825",this.dadosCupom.mensagem,"ATENÇÃO");
            } else {
              this.valorCupom = this.dadosCupom.dados.valor
              this.tipoCupom = this.dadosCupom.dados.tipoValor
              if (this.dadosCupom.dados.vendedores.length > 0) {
                let i = 0
                while (i < this.dadosCupom.dados.vendedores.length) {
                  if (this.financialManagers.salesmanId == this.dadosCupom.dados.vendedores[i]) {
                    this.cupomVendedor = true
                    break
                  } else {
                    this.cupomVendedor = false
                  }
                  i++
                }
                this.aplicaDesconto()
                /* for (let i = 0; i < this.dadosCupom.dados.vendedores.length; i++) {
                  if (this.financialManagers.salesmanId == this.dadosCupom.dados.vendedores[i]) {
                    this.cupomVendedor = true
                    this.aplicaDesconto()
                    i = this.dadosCupom.dados.vendedores.length
                  }
                  if (i == this.dadosCupom.dados.vendedores.length - 1) {
                    if (!this.cupomVendedor) {
                      this.cupomVendedor = false
                      this.aplicaDesconto()
                    }
                  }
                } */
              } else {
                this.cupomVendedor = true
                this.aplicaDesconto()
              }
            }
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Ocorreu um erro ao consultar o cupom!","DESCULPE");
          }
        }
      },

      async aplicaDesconto() {
        var vm = this;
        if (this.cupomVendedor) {
          this.dependentes.forEach(dependente => {
            if (this.dadosCupom.dados.planos.includes(dependente.plansId))
              this.cupomAplicado = true
          })
          await this.carregaDependentes()
          this.opcoesCarencia = this.dadosCupom.dados.opcoesCarencia
          this.dependentes.forEach(dependente => {
            if (this.dadosCupom.dados.tipoDesconto == "ADESÃO") {
              this.cupomAdesao = true
              if (this.dadosCupom.dados.planos.includes(dependente.plansId)) {
                if (this.dadosCupom.dados.tipoValor == 'REAL') {
                  this.primeiraParcela = (parseFloat(dependente.valuePlan.replace(",",".") - this.planoSelecionado.descontoAvista - this.dadosCupom.dados.valor))
                  this.valorAnualProposta = parseFloat(dependente.valuePlan.replace(',','.') - this.planoSelecionado.descontoAvista) * 11
                  this.valorAnualProposta = this.valorAnualProposta + this.primeiraParcela
                  dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor).toFixed(2).replace('.',',')
                } else {
                  this.primeiraParcela = parseFloat(dependente.valuePlan.replace(",",".")) - (parseFloat(dependente.valuePlan.replace(",",".") * (this.dadosCupom.dados.valor / 100)))
                  this.valorAnualProposta = parseFloat(dependente.valuePlan.replace(',','.') - this.planoSelecionado.descontoAvista) * 11
                  this.valorAnualProposta = this.valorAnualProposta + this.primeiraParcela
                  dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - parseFloat(dependente.valuePlan.replace(",",".") * this.dadosCupom.dados.valor)/100).toFixed(2).replace('.',',')
                }
              } else {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825","Cupom aplicado não é disponível para o plano selecionado!","ATENÇÃO");
              }
            } else {
              if (this.dadosCupom.dados.planos.includes(dependente.plansId)) {
                if (this.dadosCupom.dados.tipoValor == 'REAL') {
                  this.valorTotalPropostaComDesconto = (parseFloat(dependente.valuePlan.replace(",",".") - this.planoSelecionado.descontoAnual - this.dadosCupom.dados.valor) * this.dependentes.length)
                  dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - this.dadosCupom.dados.valor).toFixed(2).replace('.',',')
                  this.valorDependnte = dependente.valuePlan
                } else {
                  this.valorTotalPropostaComDesconto = (parseFloat(dependente.valuePlan.replace(",",".") - this.planoSelecionado.descontoAnual) * this.dependentes.length)
                  this.valorTotalPropostaComDesconto = this.valorTotalPropostaComDesconto - (this.valorTotalPropostaComDesconto * this.dadosCupom.dados.valor / 100)
                  dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - parseFloat(dependente.valuePlan.replace(",",".") * this.dadosCupom.dados.valor)/100).toFixed(2).replace('.',',')
                  this.valorDependnte = dependente.valuePlan
                }
              } else {
                this.isLoading = false
                vm.$refs.chamaSnackbar.snack("#F9A825","Cupom aplicado não é disponível para o plano selecionado!","ATENÇÃO");
              }
              //this.atualizaValorPlanoDep()
            }
          });
          this.calculaValoresCupom()
        } else {
          this.financialManagers.cupomDesconto = ''
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#F9A825","Cupom informado não está disponível para o seu vendedor!","ATENÇÃO");
        }
      },

      excluiCupom() {
        this.cupomAdesao = false
        this.carregaDependentes()
      },

      calculaValoresCupom() {
        this.valorDependentes = '0,00'
        for (let index = 0; index < this.dependentes.length; index++) {
          if(!this.dependentes[index].isHolder) {
            this.valorDependentes = (parseFloat(this.valorDependentes) + parseFloat(this.dependentes[index].valuePlan.replace(',','.'))).toFixed(2).replace('.',',')
          } else {
            this.valorTitular = parseFloat(this.dependentes[index].valuePlan.replace(',','.')).toFixed(2).replace('.',',')
          }
        }
        this.valorTotalProposta = (parseFloat(this.valorTitular.replace(',','.')) + parseFloat(this.valorDependentes.replace(',','.'))).toFixed(2)
        this.financialManagers.responsibility = this.valorTotalProposta
        this.isLoading = false
      },

      //Métodos de Pagamento
      async pagamentoBoleto(pagamentoTipo) {
        if (this.contrataccept && this.contractAcceptComunicacoes && this.financialManagers.petSaudavel != '' && this.financialManagers.cpf != '' && this.financialManagers.rg != '' && this.financialManagers.rgEmitter != '') {
          this.isLoading = true
          await this.retornoViaCEP()
          this.token = ''
          this.idBoleto = ''
          /* //Pegar Token
          try {
            let res = await axios.get(`${baseApiUrl}Pagamentos/token`)
            if (res.data != '') {
              this.token = res.data.token
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao se conectar com a plataforma de pagamento, tente mais tarde!","ERRO");
            this.close()                 
          } */ 

          //Criando data de vencimeto do boleto
          var datapagvenc = new Date();
          datapagvenc.setDate(new Date().getDate() + 3)
          var nossoNum = this.financialManagers.proposalNumber.toString() +Math.floor(10 + Math.random() * 99)
          //Preencher o campos do model de Boleto
          modelBoleto.pagadorDocumentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
          modelBoleto.pagadorNome = this.financialManagers.firstName.substr(0, 39)
          modelBoleto.pagadorEndereco = this.financialManagers.address.substr(0, 39) + ', ' + this.financialManagers.addressNumber
          modelBoleto.pagadorBairro = this.bairro.substr(0, 19)
          modelBoleto.pagadorCidade = this.cidade.substr(0, 19)
          modelBoleto.pagadorUf = this.financialManagUF 
          modelBoleto.pagadorCep = this.financialManagers.cep.replace(/[^\d]+/g,'');
          modelBoleto.dataVencimento = datapagvenc.toISOString().substr(0, 10)
          modelBoleto.descontoDataLimite = datapagvenc.toISOString().substr(0, 10)
          //salvando o responsibility e o valor do boleto caso seja anual
          if (pagamentoTipo == 'anual') {
            this.financialManagers.modalidadePagamento = 'ANUAL'
            if (this.financialManagers.reteveAdesao) {
              this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
              modelBoleto.valorNominal = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace(',', '.')
            } else {
              this.financialManagers.responsibility = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace('.', ',')
              modelBoleto.valorNominal = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace(',', '.')
            }
          }
          //salvando o responsibility e o valor do boleto caso seja mensal
          else {
            this.financialManagers.modalidadePagamento = 'MENSAL'
            modelBoleto.valorNominal = parseFloat(this.valorTotalProposta.replace(',','.'))
            this.financialManagers.responsibility = this.valorTotalProposta.replace(',','.')
          }
          modelBoleto.mensagem = "Referente ao plano " + this.planoSelecionado.name + " - Proposta de Número: " + this.financialManagers.proposalNumber
          modelBoleto.nsu = this.financialManagers.proposalNumber
          modelBoleto.nossoNumero = nossoNum.substr(0,12)
          modelBoleto.seuNumero = nossoNum.substr(0,12)

          //Gerando o Boleto e pegando o ID
          try {
            let res = await axios.post(`${baseApiUrl}Pagamentos/boletosPost`,modelBoleto)
            if (res.data != '') {
              this.idBoleto = res.data.id
              // this.atualizaValorPlanoDep()
              this.cupomAplicado = false
              await this.carregaDependentes()
              await this.salvarFinancialManagerEFinalizar()
            }
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao gerar boleto. Tente novamente!","ERRO");
            this.close()                 
          }                
        } else {
          if (this.financialManagers.originRegister == 'INTERNO') {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato, selecionar a melhor data de vencimento e inserir os dados do tutor!","ATENÇÃO");
          } else {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Para gerar o boleto, é necessário concordar com os termos do contrato e selecionar a melhor data de vencimento!","ATENÇÃO");
          }
        }
      }, 
        
      async atualizaValorPlanoDep(dependente) {
        try {
          if (this.financialManagers.modalidadePagamento == 'ANUAL') {
            dependente.valuePlan = parseFloat(dependente.valuePlan.replace(",",".") - ((dependente.valuePlan.replace(",",".") * this.planoSelecionado.descontoAnual) / 100)).toFixed(2)
          }
          // dependente.valuePlan = this.valorDependnte //atribui o valor da faixa de dependentes atual conforme tabela família
          dependente.dateFirstPayment = moment().add(1, 'M').format('YYYYMM')
          if (this.pagamentoTipoCartao == 'anualParcelado')
            dependente.valuePlan = parseFloat(this.valorDependnte.replace(",",".") - this.planoSelecionado.descontoAvista).toFixed(2)
          /* if (desconto > 0) {
            if (tipoValor == 'REAL') {
              dependente.valuePlan = dependente.valuePlan - parseFloat(desconto).toFixed(2)
            } else {
              dependente.valuePlan = dependente.valuePlan - (dependente.valuePlan * (desconto / 100))
            }
          } */
          await axios.post(baseApiUrl + 'Dependents/editaDependente', dependente)
        } catch (error) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao atualizar valor do plano para os pets dependentes!","ERRO");
        }
      },

      exibeModalAceite() {
        this.modal = true
      },

      confirmaAceiteAdicional() {
        this.modal = false
      },
      
      pagamentoCartao(pagamentoTipo) {
        if (this.financialManagers.reteveAdesao && pagamentoTipo == 'mensal')
          this.pegaDadosCartao = true
        else
          this.pegaDadosCartao = false

        if (this.financialManagers.reteveAdesao) {
          this.qtdParcelas = [
            { value: 1, text: '1X' },
            { value: 2, text: '2X' },
            { value: 3, text: '3X' },
            { value: 4, text: '4X' },
            { value: 5, text: '5X' },
            { value: 6, text: '6X' },
            { value: 7, text: '7X' },
            { value: 8, text: '8X' },
            { value: 9, text: '9X' },
            { value: 10, text: '10X' },
            { value: 11, text: '11X' },
          ]
        } else {
          this.qtdParcelas = [
            { value: 1, text: '1X' },
            { value: 2, text: '2X' },
            { value: 3, text: '3X' },
            { value: 4, text: '4X' },
            { value: 5, text: '5X' },
            { value: 6, text: '6X' },
            { value: 7, text: '7X' },
            { value: 8, text: '8X' },
            { value: 9, text: '9X' },
            { value: 10, text: '10X' },
            { value: 11, text: '11X' },
            { value: 12, text: '12X' },
          ]
        }
        
        if (this.contrataccept && this.contractAcceptComunicacoes && this.financialManagers.petSaudavel != '' && this.financialManagers.cpf != '' && this.financialManagers.rg != '' && this.financialManagers.rgEmitter != '') {
          this.validadeCartao = ''
          this.pagamentoTipoCartao = pagamentoTipo
          this.dialogCartao = true
        } else {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para realizar o pagamento, é necessário concordar com os termos do contrato e inserir os dados do tutor!","ATENÇÃO");
        }
      },

      async pagarDebito() {
        if (this.financialManagers.bancoDeb == '' || this.financialManagers.agenciaDeb == '' || this.financialManagers.contaDeb == '' || this.financialManagers.diaDeb == '') {
          this.isLoading = false
          this.$validator.validateAll()
          /* var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todos os dados do cartão corretamente!","ATENÇÃO"); */
        } else {
          this.isLoading = true
          if (this.pagamentoTipoCartao == 'anual') {
            this.financialManagers.modalidadePagamento = 'ANUAL'
            this.financialManagers.responsibility = (parseFloat(this.valorTotalProposta - (this.planoSelecionado.descontoAvista * this.dependentes.length))*12).toFixed(2).replace('.', ',')
          } else {
            this.financialManagers.modalidadePagamento = 'MENSAL'
          }
          this.Sales.status = 'EM AVERBAÇÃO'
          this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
          this.financialManagers.vendedor = this.nomeVendedor
          this.financialManagers.tipoPagamento = 52
          this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
          this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
          this.formOfPayment.type = 'DEBITO'
          this.financialManagers.formOfPayment = 'DEBITO'
          if (this.dadosCupom.dados != null)
            if (this.dadosCupom.dados.tipoDesconto == 'CONTRATO')
              await this.atualizaValorPlanoDep()
          await this.salvarFinancialManagerEFinalizar()
        }
      },

      async pagarCartao() {
        if (!this.cartaValidado) {
          if (!this.modelCartao.cartao.bandeira) {
            vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Bandeira do cartão não localizada. Por favor, revise os dados!","ERRO");
          } else if (this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.bandeira == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == '') {
            this.$validator.validateAll()
          } else {
            this.isLoading = true
            await this.retornoViaCEP()
            var primeiroUltimoNome = this.financialManagers.firstName.trim().split(" ")
            this.modelCartao.id = this.encrypt(this.financialManagers.proposalNumber.toString())
            if (this.pagamentoTipoCartao == 'anual') {
              this.modelCartao.tipoTransacao = 'A_VISTA'
              this.modelCartao.quantidadeParcelas = 1
              this.financialManagers.modalidadePagamento = 'ANUAL'
              if (this.financialManagers.reteveAdesao) {
                this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                this.modelCartao.valor = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace(',', '.')
              } else {
                this.financialManagers.responsibility = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace('.', ',')
                this.modelCartao.valor = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace(',', '.')
              }
            } else if (this.pagamentoTipoCartao == 'anualParcelado') {
              this.modelCartao.tipoTransacao = 'PARCELADO_SEM_JUROS'
              this.formOfPayment.type = 'CARTAO_ANUAL'
              this.financialManagers.modalidadePagamento = 'ANUAL'
              if (this.financialManagers.reteveAdesao) {
                this.financialManagers.responsibility = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*12).toFixed(2).replace(',', '.')
                this.modelCartao.valor = parseFloat((this.valorTotalProposta - this.planoSelecionado.descontoAnual.replace(',', '.'))*11).toFixed(2).replace(',', '.')
              } else {
                this.financialManagers.responsibility = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace('.', ',')
                this.modelCartao.valor = parseFloat(this.valorTotalPropostaComDesconto * 12).toFixed(2).replace(',', '.')
              }
            } else if (this.pagamentoTipoCartao == 'mensal') {
              this.modelCartao.tipoTransacao = 'A_VISTA'
              this.modelCartao.quantidadeParcelas = 1
              this.financialManagers.modalidadePagamento = 'MENSAL'
              this.financialManagers.responsibility = this.valorTotalProposta.replace('.',',')
              this.formOfPayment.type = 'CARTAO'
              this.modelCartao.valor = this.valorTotalProposta
            }
            this.modelCartao.comprador.id = this.idUser.replace(/[^\d]+/g,'').substr(0, 9)
            this.modelCartao.comprador.documentoNumero = this.financialManagers.cpf.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.documentoTipo = '1'
            this.modelCartao.comprador.email = this.financialManagers.email
            this.modelCartao.comprador.nomeCompleto = this.financialManagers.firstName
            this.modelCartao.comprador.primeiroNome = primeiroUltimoNome[0]
            this.modelCartao.comprador.ultimoNome = primeiroUltimoNome[primeiroUltimoNome.length - 1]
            this.modelCartao.comprador.enderecoLogradouro = this.financialManagers.address
            this.modelCartao.comprador.enderecoNumero = this.financialManagers.addressNumber
            this.modelCartao.comprador.enderecoComplemento = this.financialManagers.addressComplement
            this.modelCartao.comprador.enderecoCep = this.financialManagers.cep.replace(/[^\d]+/g,'')
            this.modelCartao.comprador.enderecoBairro = this.bairro
            this.modelCartao.comprador.enderecoCidade = this.cidade
            this.modelCartao.comprador.enderecoEstado = this.estado
            this.modelCartao.cartao.expiracaoAno = this.validadeCartaoAno.substr(2,4)
            //this.modelCartao.cartao.bandeira = this.getCardFlag(this.modelCartao.cartao.numero)
            this.modelCartao.cartao.bandeira = this.modelCartao.cartao.bandeira

            //Pega hash cvv e salva no FM
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
              if (res.data.encrypt != '')
                this.financialManagers.cardCvc = res.data.encrypt              
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
              return;
            }

            //Dados para o FM 
            this.financialManagers.cardCvc = this.encrypt(this.modelCartao.cartao.codigoSeguranca.toString())           
            this.financialManagers.cardNumber = this.modelCartao.cartao.numero
            this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
            this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
            //this.financialManagers.cardFlag = this.getCardFlag(this.modelCartao.cartao.numero)
            this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
            this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
            this.financialManagers.vendedor = this.nomeVendedor
            this.financialManagers.formOfPayment = 'CARTAO'
            this.salvarFinancialManager()

            try {
              let res = await axios.post(`${baseApiUrl}Pagamentos/cartaocredito`, this.modelCartao) 
              if (res.data != '') {
                this.Sales.autorizacaoCodigo = res.data.transacao.autorizacaoCodigo
                this.Sales.nsu = res.data.transacao.nsu
                this.Sales.paymentId = res.data.pagamentoId
                this.financialManagers.autorizacaoCodigo = res.data.transacao.autorizacaoCodigo
                this.financialManagers.nsu = res.data.transacao.nsu
                this.financialManagers.paymentId = res.data.pagamentoId
                this.financialManagers.tokenCartao = res.data.cartaoId
                this.financialManagers.cardCvc = ''
                this.financialManagers.cardNumber = ''
                this.financialManagers.cardValidity = ''
                this.financialManagers.cardHolderName = ''
                this.financialManagers.cardFlag = ''
                this.Sales.status = 'EM VALIDAÇÃO'
                this.financialManagers.tipoPagamento = 52
                this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
                this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
                this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
                this.cartaValidado = true
                if (this.cartaValidado) {
                  // await this.atualizaValorPlanoDep()
                  this.cupomAplicado = false
                  await this.carregaDependentes()
                  await this.salvarFinancialManagerEFinalizar()
                } else {
                  this.isLoading = false
                  var vm = this;
                  vm.$refs.chamaSnackbar.snack("#EF5350","Transação não autorizada.","DESCULPE") 
                }
              }
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Transação não autorizada.","DESCULPE") 
            }           
            /* await axios.post("https://p4x.srv.br/api/v1.0/pagamentos/cartaocredito",this.modelCartao, { */
          }
        }
      },

      async enviarProposta() {
        var vm = this;
        this.Sales.status = 'EM VALIDAÇÃO'
        if (this.planoSelecionado.typePayment == 'BOLETO') {
          if (this.contrataccept) {
            this.financialManagers.formOfPayment = 'BOLETO'
            await this.atualizaValorPlanoDep()
            await this.salvarFinancialManagerEFinalizar()
          } else {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta, é necessário concordar com os termos do contrato!","ATENÇÃO");
          }
        } else if (this.planoSelecionado.typePayment == 'CARTAO') {
          if (!this.contrataccept) {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#F9A825","Para concluir a proposta, é necessário concordar com os termos do contrato!","ATENÇÃO");
          } else if (this.modelCartao.cartao.numero == '' || this.modelCartao.cartao.nome == '' || this.modelCartao.cartao.codigoSeguranca == '' || this.modelCartao.cartao.expiracaoMes == '' || this.validadeCartaoAno == '') {
            this.$validator.validateAll()
          } else {
            this.isLoading = true
            //Pega hash cvv e salva no FM
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/encrypt`,{"text": this.modelCartao.cartao.codigoSeguranca})
              if (res.data.encrypt != '')
                this.financialManagers.cardCvc = res.data.encrypt
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao processar solicitação, tente mais tarde!","ERRO");
              return;
            }
            this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
            this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
            this.formOfPayment.type = 'CARTAO'
            this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
            this.financialManagers.formOfPayment = 'CARTAO'
            this.financialManagers.cardNumber = this.modelCartao.cartao.numero
            this.financialManagers.cardValidity = this.modelCartao.cartao.expiracaoMes + this.validadeCartaoAno
            this.financialManagers.cardHolderName = this.modelCartao.cartao.nome
            this.financialManagers.cardFlag = this.modelCartao.cartao.bandeira
            await this.atualizaValorPlanoDep()
            await this.salvarFinancialManagerEFinalizar()
          }
        }
      },
      
      //Função para criptografia
      encrypt(text) {
        let crypto = require('crypto');
        let password = 'pxuelh2so839ljis';
        let iv = 'pxuelh2so839ljis';
        let cipher = crypto.createCipheriv('aes-128-cbc', password, iv);
        let encryptedData = cipher.update(text, 'utf8', 'Base64') + cipher.final('Base64');
        return encryptedData;
      },

      async enviaAnexos() {
        this.Anexos.id = this.idUser 
        try {
          await axios.post(`${baseApiUrl}ImagesDocs/saveDocsFinancialManager`,this.Anexos)
        } catch (error) {
          //
        }
      },

      async salvarDependentesCarregados() {
        for (var i=1; i<=this.financialManagers.qtdDependentes; i++) {
          this.dependents.dateOfBirth = this.formatDate(this.dependentesCarregados[i].DataNascimento)
          this.dependents.plansId = this.planoSelecionado.id
          this.dependents.valuePlan = this.planoSelecionado.valorDependnte
          this.dependents.rcaId = '8'
          this.dependents.financialManagerId = this.idUser
          this.dependents.isHolder = false
          this.dependents.firstName = this.dependentesCarregados[i].Nome
          //this.dependents.gender = this.financialManagers.gender
          //this.dependents.maritalStatus = this.financialManagers.maritalStatus
          this.dependents.cpf = this.dependentesCarregados[i].CPF
          this.dependents.motherName = this.dependentesCarregados[i].NomeMaeDependente
          this.dependents.susNumber = this.dependentesCarregados[i].CNS
          /* switch (this.dependentesCarregados[i].CodGrauParentesco) {
            case 3:
                this.dependents.parentage = 'CÔNJUGE'
              break;
            case 4:
                this.dependents.parentage = 'FILHO'
              break;
            case 6:
                this.dependents.parentage = 'ENTEADO'
              break;
            case 8:
                this.dependents.parentage = 'PAI/MÃE'
              break;
            case 10:
                this.dependents.parentage = 'OUTRO'
              break;          
            default:
              break;
          } */

          await axios.post(baseApiUrl + 'Dependents/editaDependente', this.dependents).then(res => {         
            if (res.data != '') {
              this.carregaDependentes()
              this.dependents = Object.assign({}, this.defaultDependents)
              //this.qtdDependentesInseridos = res.data
            }              	
          })
        }
      },

      async salvarDependente() {
        await this.$validator.validate('dateOfBirthDep').then(valid => {
          if (!valid)
            this.validarDataNascDep = false
          else
            this.validarDataNascDep = true
        });
        this.dependents.dateOfBirth = this.formatDate(this.dataNascDependent)
        this.dependents.rcaId = '8'
        this.dependents.financialManagerId = this.idUser
        //this.selecionaPlanoDepend()     
        if (this.tipoTitular) {
          this.dependents.isHolder = true
          this.dependents.cpf = ""
        } else {
          this.dependents.isHolder = false 
          this.dependents.parentage = 'OUTRO'
        }
        if (this.dependents.dateOfBirth == '' || this.dependents.firstName == '' || this.dependents.gender == null || !this.validarDataNascDep || this.selecaoPlano == '')
          this.$validator.validateAll() 
        else if (this.selecionaPlanoDepend()) {
          this.dependents.maritalStatus = 'SOLTEIRO'
          this.dependents.motherName = 'Não Informado'
          this.dependents.firstName = this.dependents.firstName.toUpperCase()                          
          await axios.post(baseApiUrl + 'Dependents/editaDependente', this.dependents).then(res => {    
            if (res.data != '') {
              this.carregaDependentes()
              this.close()
            }              	
          })
          if (this.dependents.parentage == '') {
            this.alertTitular = false 
          } 
        } else {
          if (this.idadeMaxPlan == 100) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825",`Para o plano selecionado, o pet deve ter a idade mínima de ${this.idadeMinPlan} anos.`,"ATENÇÃO")
          } else {
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825",`Para o plano selecionado, o pet deve ter de ${this.idadeMinPlan} a ${this.idadeMaxPlan} anos.`,"ATENÇÃO")
          }
        }
      },

      async salvarFinancialManagerEFinalizar() { 
        if (this.planoSelecionado.typePayment == 'BOLETO') {
          //Pegar o formOfPayment e salvar o FinancialManager
          this.financialManagers.vendedor = this.nomeVendedor
          this.financialManagers.nsu = modelBoleto.nsu
          this.financialManagers.situacaoBoleto = 'GERADO'
          this.financialManagers.nossoNumero = modelBoleto.nossoNumero
          this.financialManagers.vencimentoBoleto = modelBoleto.dataVencimento
          this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
          //this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 8)+Math.floor(10 + Math.random() * 10)
          this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
          this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
          this.formOfPayment.type = 'BOLETO'
          this.financialManagers.formOfPayment = 'BOLETO'
          /* this.financialManagers.existSales = true  */
          this.Sales.boletoId = this.idBoleto 
        }
        if (this.planoSelecionado.typePayment == 'CARTAO') {
          //Pegar o formOfPayment e salvar o FinancialManager
          this.financialManagers.vendedor = this.nomeVendedor
          this.financialManagers.dateSignatureContract = new Date().toISOString().substr(0, 10)
          this.formOfPayment.costCenterId = this.planoSelecionado.costCenterId
          this.formOfPayment.dayInclusion = parseInt(new Date().toISOString().substr(8, 2).replace(/^(0+)(\d)/g,"$2"))
          this.financialManagers.formOfPayment = 'CARTAO'
        }
        try {
          let res = await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers) 
          if (res.data != '') {
            this.finalizaCadastro()
          } else {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta. Tente novamente!","ERRO")
          }            
        } catch (error) {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta. Tente novamente!","ERRO")
        }                       
      },

      async finalizaCadastro() {
        //PEGA O CONTRACT NUMBER S4
        try {
          let res = await axios.post(`${baseApiUrl}FormOfPayments/firstPaymentDate`,this.formOfPayment)
          if (res.data != '') {
            this.financialManagers.contractNumberS4 = res.data.codeS4
            //this.salvarFinancialManager()
          } else {             
            this.financialManagers.contractNumberS4 = ''
            //this.salvarFinancialManager()
          }
        } catch (error) {
          this.financialManagers.contractNumberS4 = ''
          //this.salvarFinancialManager()
        }
          
        //ATUALIZA O FINANCIAL MANAGER E SALVA O SALES
        if (this.financialManagers.contractNumberS4 != undefined) {
          try {
            await axios.post(baseApiUrl + 'FinancialManagers/editaProposta', this.financialManagers)            
          } catch (error) {
            this.isLoading = false
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Erro Salvar Responsável Financeiro","ERRO");
          }
          if (Object.entries(this.vendedorLink).length != 0) {
            this.Sales.brokerId = this.vendedorLink.brokerId
            this.Sales.salesmanId = this.vendedorLink.id
            try {
              let res = await axios.get(`https://api.ipify.org/?format=json`)
              if (res.data != null) {
                this.Sales.fMIPConfirm = res.data.ip 
                this.Sales.salesmanIPConfirm = res.data.ip 
              } else {
                this.Sales.fMIPConfirm = '127.0.0.30'
                this.Sales.salesmanIPConfirm = '127.0.0.30'
              }
            } catch (error) {
              this.Sales.fMIPConfirm = '127.0.0.50'
              this.Sales.salesmanIPConfirm = '127.0.0.50'
            }
            this.Sales.financialManagerId = this.idUser
            this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
            this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSales`,this.Sales)
              if (res.data == true) {
                if (this.planoSelecionado.typePayment == 'BOLETO') {
                  if (!this.financialManagers.reteveAdesao)
                    this.imprimirBoleto()
                  setTimeout(() => {
                    this.isLoading = false
                    this.dialogLoading = true
                  }, 4000);
                } else {
                  this.isLoading = false
                  this.dialogLoading = true
                }
              } else {   
                this.isLoading = false
                this.dialogLoading = true          
                /* this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") */  
              }
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
          } else {
            if (this.planoSelecionado.typePayment == 'FUJIOKA') {
              this.Sales.brokerId = this.planoSelecionado.brokerIdDefault
              this.Sales.salesmanId = this.planoSelecionado.salesmanIdDefaut
            } else {
              this.Sales.brokerId = this.brokerSaudePet
              this.Sales.salesmanId = this.salaesSaudePet
            }
            try {
              let res = await axios.get(`https://api.ipify.org/?format=json`)
              if (res.data != null) {
                this.Sales.fMIPConfirm = res.data.ip 
                this.Sales.salesmanIPConfirm = res.data.ip 
              } else {
                this.Sales.fMIPConfirm = '127.0.0.0' 
                this.Sales.salesmanIPConfirm = '127.0.0.0'
              }
            } catch (error) {
              this.Sales.fMIPConfirm = '127.0.0.0' 
              this.Sales.salesmanIPConfirm = '127.0.0.0'  
            }
            this.Sales.financialManagerId = this.idUser
            this.Sales.fMConfirm = new Date().toISOString().substr(0, 10)
            this.Sales.salesmanConfirm = new Date().toISOString().substr(0, 10)
            try {
              let res = await axios.post(`${baseApiUrl}FinancialManagers/setExistSales`,this.Sales)
              if (res.data == true) { 
                if (this.planoSelecionado.typePayment == 'BOLETO') {
                  if (!this.financialManagers.reteveAdesao)
                    this.imprimirBoleto()
                  setTimeout(() => {
                  this.isLoading = false
                  this.dialogLoading = true
                  }, 4000);
                } else {
                  this.isLoading = false
                  this.dialogLoading = true
                }
              } else {
                this.isLoading = false
                this.dialogLoading = true             
                /* this.isLoading = false
                vm = this;
                vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") */  
              }
            } catch (error) {
              this.isLoading = false
              vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar a proposta, tente novamente!","ERRO") 
            }
          }
        } else {
          this.isLoading = false
          vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um erro ao capturar a forma de pagamento, tente novamente!","ERRO")  
        }
      },

      async imprimirBoleto() {
        //Baixando Boleto PDF
        try {
          let res = await axios.get(`https://p4x.srv.br/api/v1.0/boletos/${this.idBoleto}/imprimir`,{ responseType: 'arraybuffer', headers: {
              Authorization: 'Bearer ' + this.token, //the token is a variable which holds the token
              'Content-type': 'application/pdf'
            }
          })
          if (res.data != null) {
            //Create a Blob from the PDF Stream
            const file = new Blob(
              [res.data], 
              {type: 'application/pdf'}
            );
            //Build a URL from the file
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement('a');
            link.href = fileURL;
            link.setAttribute('download', 'boleto.pdf'); //or any other extension
            document.body.appendChild(link);
            link.click();
            //Open the URL on new Window
            window.open(fileURL);                           
          }
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao imprimir boleto. Tente novamente ou entre em contato com a " + this.informacaoOperadora("nome") + "!","ERRO");
          this.close()                 
        }
      },

      openDialog() {
        // this.selecionaPlanoDepend()
        this.tipoTitular = true
        this.$validator.reset()
        this.dependents = Object.assign({}, this.defaultDependents)
        this.editedIndexTitular = ''
        this.dataNascDependent = ''
        this.dependents.isHolder = true
        this.dialog = true
      },

      openDialogDependete() {
        if (this.dependentes.length == 5) {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Limite máximo atingido por contratação","DESCULPE!");
        } else {
          this.tipoTitular = false
          this.$validator.reset()
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.dataNascDependent = ''
          this.dialog = true
          //this.selecionaPlanoDepend()
        }
      },

      async carregaEspecieRacas() {
        await axios.get(baseApiUrl + 'Especies').then(response => {
          if (response.data) {
            this.especies = response.data
          }
        })
        await axios.get(baseApiUrl + 'racas?filter={"include":"especie"}').then(response => {
          if (response.data) {
            this.racas = response.data
          }
        })
      },

      openDialogDelete(item) {
        this.editedIndex = item.id
        this.dependents = Object.assign({}, item)
        this.$validator.reset()
        this.dialogDelete = true
      },
      
      close() {
        this.dialogCartao = false
        this.dialogLoading = false
        this.dialog = false
        this.dialogDelete = false
        this.$validator.reset()          
        setTimeout(() => {
          this.modelCartao = Object.assign({}, this.defaltModelCartao)
          this.$validator.reset()
          this.usarDadosFM = true
        }, 800);
        setTimeout(() => {
          this.dependents = Object.assign({}, this.defaultDependents)
          this.editedIndex = ''
          this.editedIndexTitular = ''
          this.dataNascDependent = ''
        }, 300)
      },

      confirmaContrato() {
        this.close()
        this.$router.push({ path: '/areacliente' })
        setTimeout(() => {
          document.location.reload(true);
        }, 500);
      },

      async continueStep2() {
        this.financialManagers.plansId = this.planoSelecionado.id
        this.financialManagers.firstName = this.financialManagers.firstName.toUpperCase()
        this.financialManagers.email = this.financialManagers.email.toLowerCase()
        await axios.post(`${baseApiUrl}FinancialManagers/editaProposta`, this.financialManagers ).then(res => {
          if (res.data != '') {
            this.idUser = res.data.id
            this.$validator.reset()
            this.financialManagers.proposalNumber = this.idUser.replace(/[^\d]+/g,'').substr(0, 6) + Math.floor(1000 + Math.random() * 1000)
            this.financialManagers.stageForm = 2
            this.salvarFinancialManager()
            this.dialogStep1 = false
            this.e1 = 2
            this.isLoading = false
          }
        })
      },

        getCardFlag(cardnumber) {
          cardnumber.replace(/[^0-9]+/g, '');
          var cards = {
            visa      : /^4[0-9]{12}(?:[0-9]{3})/,
            mastercard : /^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/,
            diners    : /^3(?:0[0-5]|[68][0-9])[0-9]{11}/,
            /* amex      : /^3[47][0-9]{13}/,
            discover  : /^6(?:011|5[0-9]{2})[0-9]{12}/, */
            hipercard  : /^(606282\d{10}(\d{3})?)|(3841\d{15})/,
            elo        : /^((((636368)|(438935)|(504175)|(451416)|(636297))\d{0,10})|((6504)|(5067)|(4576)|(4011))\d{0,12})/,
            /* jcb        : /^(?:2131|1800|35\d{3})\d{11}/,        
            aura      : /^(5078\d{2})(\d{2})(\d{11})$/  */     
          };

          for (var flag in cards) {
            if (cards[flag].test(cardnumber)) {
              return flag.toUpperCase();
            }
          }

          return false;
        },

      //CONTROLE DE ANEXOS
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      
      inputFileRg1(newFile, oldFile) {
        if (newFile && !oldFile) {       
          var reader = new FileReader();        
          var file = this.filesRg1[0]
          //salva a base64 na variável
          reader.onloadend = function() {
            document.getElementById("rg1").value = reader.result
          };
          //Gera base64
          reader.readAsDataURL(file.file);  
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },
      
      inputFileRg2(newFile, oldFile) {
        if (newFile && !oldFile) {        
          var reader = new FileReader();        
          var file = this.filesRg2[0]
          //Gera base64
          reader.onloadend = function() {
            document.getElementById("rg2").value = reader.result
          }; 
          reader.readAsDataURL(file.file);  
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCPF(newFile, oldFile) {
        if (newFile && !oldFile) {        
          var reader = new FileReader();        
          var file = this.filesCPF[0]
          //Gera base64
          reader.onloadend = function() {
            document.getElementById("cpf").value = reader.result
          };
          reader.readAsDataURL(file.file);  
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileAddress(newFile, oldFile) {
        if (newFile && !oldFile) {        
          var reader = new FileReader();        
          var file = this.filesAddress[0]
          //Gera base64
          reader.onloadend = function() {
            document.getElementById("address").value = reader.result
          }; 
          reader.readAsDataURL(file.file);
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileOutros(newFile, oldFile) {
        if (newFile && !oldFile) {        
          var reader = new FileReader();        
          var file = this.filesOutros[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("outros").value = reader.result
          };
          reader.readAsDataURL(file.file);  
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },
      //FIM CONTROLE DE ANEXOS
      
      calculateAge(dobString) {
        var dob = new Date(dobString);
        var currentDate = new Date();
        var currentYear = currentDate.getFullYear();
        var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
        var age = currentYear - dob.getFullYear();
        if (birthdayThisYear > currentDate) {
          age--;
        }
        return age;
      },

      async pegaParametrosUrl() {
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          //Criar objeto que vai conter os parametros
          var paramArray = {};
          //Passar por todos os parametros
          for (var i=0; i<params.length; i++) {
            //Dividir os parametros chave e valor
            var param = params[i].split('=');
            //Adicionar ao objeto criado antes
            paramArray[param[0]] = param[1];
          }
          if (paramArray['plano']) {
            sessionStorage.clear()
            try {        
              let res = await axios.get(`${baseApiUrl}Plans?filter[where][id]=${paramArray['plano']}`)
              if (res.data != null) {
                this.financialManagers.plansId = paramArray['plano']                
                this.planoSelecionado = res.data[0]            
                this.selecionaPlanoDepend()
                this.pdfSelecionado = this.planoSelecionado.urlContrato
                this.dependents.namePlan = res.data[0].name  
              }
            } catch (error) {
              var vm = this;
              vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao carregar informações do plano, tente novamente!","ERRO");
            }
          }
          if (paramArray['vendedor']) {
            await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(res => {
              if (res.data != null) {
                this.vendedorLink = res.data[0] 
                this.temVendedor = true
                this.linkVendedor = true
                this.nomeVendedor = this.vendedorLink.linkSite
                this.financialManagers.vendedor = this.vendedorLink.linkSite 
                this.financialManagers.CPFVendedor =  this.vendedorLink.cpf     
                this.financialManagers.salesmanId = this.vendedorLink.id  
                this.financialManagers.brokerId = this.vendedorLink.brokerId        
              }
            })
          } 
        }
        this.isLoading = false
      }
    },
  }
</script>

<style>
  .v-table__overflow {
    border-radius: 10px;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
  }

  span.v-stepper__step__step.primary{
    background-color: #8395A7!important;
    border-color: #8395A7!important;
  }

  .theme--light.v-stepper .v-stepper__label {
    color: #8395A7;
  }

  .theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {
    color: #8395A7;
  }

  table.v-table thead tr th {
    background-color: #8395A7;
    font-size: 1rem;
  }

  .v-list__tile.theme--light{
    justify-content: center;
  }

  .centralizar {
    text-align: left;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 auto;
    flex: none;
    overflow: hidden;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: start;
    -ms-flex-align: start;
    align-items: flex-start;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -ms-flex-direction: column;
    flex-direction: column;
  }

  .theme--light.v-table thead th  {
    color: white;
  }

  .theme--light.v-datatable thead th.column.sortable:hover {
    color: rgb(17, 16, 16);
  }

  .theme--light.v-datatable thead th.column.sortable.active {
    color: white;
    font-weight: bold;
  }

  table.v-table thead th:first-child, table.v-table tbody th:first-child {
    padding: 15px 24px;
  }

  .form-titulo {
    font-size: 22px;
    font-weight: 700;
    color: #8395A7;
    margin-bottom: 20px;
  }

  hr {
    border: 0;
    width: 100%;
    height: 1px;
    background-image: linear-gradient(to right,
      rgba(120, 120, 120, 0),
      rgba(120, 120, 120, 0.75),
      rgba(120, 120, 120, 0)
    );
  }

  .resumo p {
    margin-bottom: 0;
    font-size: 16px;
    line-height: 20px;
    color: #828585;
  }

  .subtotal {
    font-weight: 700;
    font-size: 20px;
    color: #828585;
  }

  .total {
    font-size: 30px;
    color: #8395A7;
    line-height: 30px;
    margin-top: 5px;
    display: block;
    font-weight: bold;
  }

  .page-content p {
    margin-bottom: 0;
  }

  .cardpag {
    background-color: #8395A7;
    color: white;
    /* color: #8395A7; */
    justify-content: center;
    font-weight: 700;
    font-size: 20px;
  }

  a {
    text-decoration: none
  }

  .imgpag {
    opacity: 0.5;
  }
</style>
